// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  height: 100vh;
  background: #fff;
}

#botWrapper {
  display: flex;
  width: 100%;
  position: relative;
  justify-content: center;
  padding: 0px 5px;
  background: #fff !important;
}

body::ng-deep {
  overflow-y: hidden !important;
}

.second-level-menu {
  background: transparent !important;
  min-width: auto !important;
  max-width: 350px !important;
}

header {
  border-left: 0px !important;
  height: auto !important;
}

.chat-header {
  height: auto;
  justify-content: center;
  margin-top: 10px;
  position: relative;
  display: flex;
}

.chat-header,
.chat-content {
  width: 100%;
  display: flex;
  margin: 10px auto;
}

#botinput-wrapper ul.dropdown-menu,
#chat-list-content ul.dropdown-menu {
  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
}
#botinput-wrapper ul.dropdown-menu li,
#chat-list-content ul.dropdown-menu li {
  display: flex;
  align-items: center;
  padding-left: 10px;
  color: #666;
  height: 30px;
  cursor: pointer;
}
#botinput-wrapper ul.dropdown-menu li:hover,
#chat-list-content ul.dropdown-menu li:hover {
  background: #f1f1f1;
}

#chat-list-content ul.dropdown-menu li {
  gap: 10px;
}

.chat-content {
  width: 90%;
  justify-content: space-evenly;
}

.wrapper {
  display: flex;
  height: 100%;
  flex-direction: row;
  justify-content: stretch;
}

.chat-sidebar {
  max-width: 320px;
  height: 100%;
  background: #fff;
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 0px 2.6px;
}

.chatBotstyle {
  display: flex;
  flex-direction: row;
  width: 100% !important;
  height: 100%;
}

.hide {
  display: none;
}

.fa {
  cursor: pointer;
}

.chat-box-wrapper {
  position: relative;
  display: flexbox;
  width: 90%;
}

.chat-left-content {
  background: #fff;
  min-width: 280px;
  overflow-y: auto;
  /* box-shadow:2px 0px 0px rgba(0, 0, 0, 0.21); */
  /* box-shadow:3px 0px #e9e9e9; */
}

.chat-right-content {
  /* margin-left:20px; */
  /* width: clamp(300px,150vw,70vw); */
  min-width: 70%;
  width: 100%;
  overflow-y: auto;
  display: flex;
  justify-content: space-evenly;
}

#title {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: space-evenly;
  margin: 10px 0px;
  font-size: 16px;
  font-weight: bold;
}

.chat-history-list {
  height: 100vh;
  width: 100%;
  margin-left: 0px;
  position: absolute;
  z-index: 9;
  right: 0px;
  top: 0px;
}
.chat-history-list .left-box-shadow {
  box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;
}
.chat-history-list .listing-data {
  height: 90vh;
  overflow-y: auto;
  background: #fff;
  padding-bottom: 1.5em;
  padding-left: 0.5rem;
}
.chat-history-list .listing-data.templatesection {
  height: 100vh;
}
.chat-history-list .audio-wrapper {
  position: absolute;
  z-index: 999;
  right: -2rem;
  background: rgba(0, 0, 0, 0.5);
}
.chat-history-list .audio-wrapper.is-active {
  display: block;
}

select {
  appearance: base-select;
  color: var(--textsecondarycolor) !important;
  background-color: transparent;
  width: 180px;
  height: 2rem;
  font-size: 1rem;
  box-sizing: border-box;
  padding: 0.5rem 0.75rem;
  border: 1px solid #a7a7a7;
  border-radius: calc(0.5rem - 2px);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  cursor: pointer;
}
select > button {
  display: flex;
  width: 100%;
  font-family: inherit;
  color: currentColor;
}
select > button > svg {
  margin: 0 0 0 auto;
  width: 1.2rem;
  height: 1.2rem;
}
select:has(option:not([hidden]):checked) {
  color: var(--textsecondarycolor);
}
select:focus-visible {
  outline: 2px solid #a1a1aa;
  outline-offset: -1px;
}
select::picker-icon {
  display: none;
}
select::picker(select) {
  appearance: base-select;
  border: 1px solid #e4e4e7;
  padding: 0.25rem;
  margin-top: 0.25rem;
  border-radius: calc(0.5rem - 2px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  cursor: default;
  transition: opacity 225ms ease-in-out, transform 225ms ease-in-out;
  transform-origin: top;
  transform: translateY(0);
  opacity: 1;
}
@starting-style {
  select::picker(select) {
    transform: translateY(-0.25rem) scale(0.95);
    opacity: 0;
  }
}
select optgroup label {
  display: block;
  padding: 0.375rem 0.5rem;
}
select option {
  padding: 0.375rem 0.5rem;
  border-radius: calc(0.5rem - 4px);
  outline: none;
}
select option::after {
  content: "";
  width: 1rem;
  height: 1.5rem;
  margin-left: auto;
  opacity: 0;
}
select option::checkmark {
  display: none;
}
select option:checked {
  background-color: #f4f4f5;
}
select option:checked::after {
  opacity: 1;
}
select option:hover, select option:focus-visible {
  background-color: #f4f4f5;
  color: var(--textsecondarycolor);
}

.select:not(.is-multiple):not(.is-loading)::after {
  right: 1.5em;
  z-index: 4;
  top: 15px;
  font-size: 1rem;
}

::ng-deep .audio-file-class {
  width: 100%;
  min-width: 300px;
}

.chat-history-list ul {
  margin: 10px 0px;
  padding: 0px 10px;
  list-style: none;
  display: flex;
  flex-direction: column;
  line-height: 1.2rem;
}
.chat-history-list ul li {
  display: inline-flex;
  justify-content: space-evenly;
  align-items: baseline;
  border-bottom: 1px solid var(--bodyBgColor) !important;
  color: #000 !important;
}
.chat-history-list ul li label:first-child {
  display: inline-block;
  border-radius: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  font-size: 0.9rem;
  min-height: 25px;
  padding: 10px 10px;
  margin-bottom: 10px;
  width: 90%;
}
.chat-history-list ul li label:last-child {
  margin: 0% 3%;
  display: inline-block;
  width: 5%;
  padding-left: 2%;
}

#chat-list-content {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  max-width: 960px;
  font-size: 0.9rem !important;
  max-height: 66vh;
  min-height: 66vh;
  overflow-y: auto;
  scrollbar-width: none;
}

/* #chat-list-content.left-tab-show{
    width: 65%;
    #chat-list{
        width:95%;
        margin-left:0%;
    }
}

#chat-list-content.right-tab-show{
    width: 65%;
    #chat-list{
        width:98%;
        margin-left:0%;
    }
}
#chat-list-content.left-tab-show.right-tab-show{
    width:54%;
    #chat-list{
        width:65%;
    }
} */
#chat-list {
  width: 100%;
  display: inline-block;
  margin-left: 0rem;
  padding-bottom: 5%;
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}

#chat-list::-webkit-scrollbar {
  display: none;
}

.chat-list-row {
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: 960px;
}

#chat-message-enter-box {
  background: #fbfbfb;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  border-radius: 1rem;
  z-index: 1;
  border: 1px solid #dcdcdc;
}
@media screen and (max-width: 767px) {
  #chat-message-enter-box {
    border-radius: 1.5rem;
    padding: 5px;
  }
}
#chat-message-enter-box form {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
}
@media screen and (max-width: 767px) {
  #chat-message-enter-box form {
    padding: 5px;
  }
}
#chat-message-enter-box textarea {
  width: 100% !important;
  border: none;
  padding: 10px;
  color: #666;
  font-size: 1em;
  resize: none;
  height: 55px;
}
@media screen and (max-width: 767px) {
  #chat-message-enter-box textarea {
    padding: 8px;
    font-size: 0.9rem;
    height: 50px;
  }
}
@media screen and (max-width: 480px) {
  #chat-message-enter-box textarea {
    padding: 6px;
    font-size: 0.85rem;
    height: 45px;
  }
}
#chat-message-enter-box span {
  display: inline-block;
  color: #666;
  width: 100% !important;
  padding: 10px;
  color: #666;
  font-size: 1em;
  min-height: 40px;
}
@media screen and (max-width: 767px) {
  #chat-message-enter-box span {
    padding: 8px;
    font-size: 0.9rem;
    min-height: 35px;
  }
}
@media screen and (max-width: 480px) {
  #chat-message-enter-box span {
    padding: 6px;
    font-size: 0.85rem;
    min-height: 30px;
  }
}

/* .chat-header > span{
    display: inline-block;
        color: #666;
        width: 90% !important;
        padding: 10px;
        color: #666;
        font-size:1em;
        min-height:100px;
} */
.fa-cloud,
.fa-user-circle {
  color: #9da0a3;
  margin-top: 5px;
  font-size: 30px !important;
}

app-toggle-icon::ng-deep .fa-microphone-slash,
.fa-microphone-slash {
  opacity: 0.5 !important;
}

textarea::placeholder {
  color: rgb(182, 182, 182) !important;
}

.question {
  background: #848a92;
  /* background: #9da0a3;   */
  /* background: #01488f; */
  min-height: 50px;
  border-radius: 5px;
  padding: 10px;
  color: #fff;
  margin-bottom: 10px;
  width: 100%;
  margin-left: 20px;
  position: relative;
  /* box-shadow: 2px 2px 3px #000; */
  /* box-shadow: rgba(25, 118, 210, 0.35) 0px 5px 15px; */
  /* box-shadow: rgba(109, 129, 153, 0.35) 0px 5px 15px; */
}

.question::before {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: -20px;
  right: auto;
  top: 0px;
  bottom: auto;
  border: 21px solid;
  border-color: #848a92 transparent transparent transparent;
  /* border-color: #9da0a3 transparent transparent transparent;  */
  /* border-color:#01488f transparent transparent transparent; */
}

.question.align-right {
  /* background: #f2fcff; */
  background: #9da0a3;
  min-height: 50px;
  border-radius: 5px;
  padding: 10px;
  color: #fff;
  margin-bottom: 10px;
  width: 100%;
  margin-left: 50%;
  margin-right: 15px;
  position: relative;
}

.question.align-right::before {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: auto;
  right: -20px;
  top: 0px;
  bottom: auto;
  border: 21px solid;
  border-color: #848a92 transparent transparent transparent;
}

video {
  margin: 10px 0px;
}

.answer {
  background: #fff;
  min-height: 50px;
  border-radius: 5px;
  padding: 10px;
  color: #666;
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-left: 19px;
  /* box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px; */
}
.answer .answer-header {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-right: 10px;
  gap: 15px;
}
.answer .audio {
  cursor: pointer;
}
.answer .menu-list {
  position: relative;
}
.answer .menu-list ul {
  position: absolute;
  /* background: #f5fdff; */
  /* padding: 10px; */
  /* z-index: 9999; */
  top: -10px;
  right: 0px;
  width: max-content;
  /* box-shadow: 3px 3px #008cb3;
        border-radius:5px;
        border: 1px solid #95bdc7; */
}
.answer .menu-list ul li {
  margin: 10px 10px !important;
  display: inline-block;
  cursor: pointer;
  /* .fa{
           color: #008cb3;
          } */
}
.answer .menu-list ul li:hover .fa {
  color: #008cb3;
}
.answer .menu-list ul.active {
  display: block;
}
.answer .menu-list label {
  width: 20px;
  display: flex;
  justify-content: center;
  cursor: pointer;
}

.answer-content::before {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: -32px;
  right: auto;
  top: -35px;
  bottom: auto;
  border: 21px solid;
  border-color: #fff transparent transparent transparent;
}

.answer-content {
  position: relative;
  margin-top: 25px;
}
.answer-content ol {
  padding: 30px;
}

.chat-icon {
  width: 32px;
  height: 32px;
  border-radius: 100%;
  background: #d2daf3;
}
.chat-icon img {
  border-radius: 100%;
}

.username {
  width: 36px;
  height: 36px;
  border-radius: 100%;
  background: #d2daf3;
  color: #133aa5;
  vertical-align: middle;
  text-align: center;
  font-size: 22px;
  margin-right: 5px;
  display: inline-block;
  text-transform: uppercase;
}

#chatForm {
  width: 98%;
  height: inherit;
}

#chatForm > span {
  width: 90%;
  height: inherit;
  margin-left: 10px;
}

#expand-collapse {
  position: relative;
  margin-top: 25px;
  height: 15px;
}
#expand-collapse i {
  background: #fff;
  padding: 7px;
}
#expand-collapse .fa {
  font-size: 1.5em !important;
  transform: rotate(180deg) translateX(0px);
  transform-origin: 50% 20%;
}

#expand-collapse-right {
  position: relative;
  height: 15px;
}
#expand-collapse-right i {
  background: #fff;
  padding: 7px;
}
#expand-collapse-right .fa {
  font-size: 1.5em !important;
  transform: rotate(0deg) translateX(0px);
  transform-origin: 50% 20%;
}

::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #fff;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #fff;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #fff;
}

#chat-content-wrapper header {
  background: transparent !important;
  padding: 5px !important;
}

#voice-message {
  width: 80% !important;
  position: relative;
  margin-top: -40px;
  margin-left: 10px;
  padding-right: 10px;
  height: 40px;
}
#voice-message span {
  display: inline-block;
  color: #4d4d4d;
}

#chat-tools-wrapper {
  display: flex;
  width: 100%;
  justify-content: end;
  padding: 10px;
  border-bottom-right-radius: 2rem;
  border-bottom-left-radius: 2rem;
}
@media screen and (max-width: 767px) {
  #chat-tools-wrapper {
    justify-content: center;
    padding: 8px;
    border-bottom-right-radius: 1.5rem;
    border-bottom-left-radius: 1.5rem;
  }
}

#chat-tools {
  display: flex;
  list-style-type: none;
  width: auto;
  flex-direction: row;
  gap: 20px;
  padding: 0px;
  margin: 0px;
  position: relative;
  right: 10px;
  /* Rounded sliders */
}
#chat-tools li {
  display: flex;
  align-items: center;
}
#chat-tools .pi-send {
  transform: rotate(45deg);
}
#chat-tools .pi, #chat-tools .fa {
  font-size: 1.2rem !important;
}
#chat-tools li.selected-docs-menu {
  position: relative;
}
#chat-tools li.selected-docs-menu .hover-menu {
  display: none;
  position: absolute;
  right: 0;
  top: 28px;
  min-width: 220px;
  max-width: 420px;
  max-height: 260px;
  overflow-y: auto;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  padding: 8px 0;
  z-index: 1000;
}
#chat-tools li.selected-docs-menu:hover .hover-menu {
  display: block;
}
#chat-tools li.selected-docs-menu .hover-menu .menu-header {
  font-weight: 600;
  font-size: 0.85rem;
  padding: 6px 12px 8px 12px;
  border-bottom: 1px solid #f0f0f0;
  color: #333;
}
#chat-tools li.selected-docs-menu .hover-menu .menu-list {
  list-style: none;
  margin: 0;
  padding: 6px 0;
}
#chat-tools li.selected-docs-menu .hover-menu .menu-list li {
  font-size: 0.85rem;
  color: #444;
  padding: 6px 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 380px;
}
#chat-tools li.selected-docs-menu .hover-menu .menu-list li:hover {
  background: #f7f7f7;
}
#chat-tools .switch {
  position: relative;
  display: inline-block;
  width: 35px;
  height: 20px;
}
#chat-tools .switch span {
  min-height: 20px;
}
#chat-tools .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
#chat-tools .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
}
#chat-tools .slider:before {
  position: absolute;
  content: "";
  height: 15px;
  width: 15px;
  left: 4px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
}
#chat-tools input:checked + .slider {
  background-color: var(--primaryColor);
}
#chat-tools input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}
#chat-tools input:checked + .slider:before {
  transform: translateX(13px);
}
#chat-tools .slider.round {
  border-radius: 34px;
}
#chat-tools .slider.round:before {
  border-radius: 50%;
}

[hidden] {
  display: none !important;
}

.comment-area-box::after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  top: 1px;
  left: 99%;
  box-sizing: border-box;
  border: 10px solid rgba(0, 0, 0, 0.5);
  border-color: transparent transparent #fff #fff;
  transform-origin: 0 0;
  transform: rotate(135deg);
  box-shadow: -1px 1px 1px 0 rgba(0, 0, 0, 0.35);
}

.comment-area-box {
  position: absolute;
  z-index: 999;
  top: 40px;
  right: 0px;
  display: none;
  background: #fff;
  padding: 20px 40px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 5px;
  width: 300px;
}
.comment-area-box label {
  width: -moz-fit-content !important;
  width: fit-content !important;
}
.comment-area-box textarea {
  resize: none;
}
.comment-area-box .form-btns {
  width: 100%;
  display: flex;
  margin: 10px 0px;
}
.comment-area-box .form-btns .btn:first-child {
  border: 1px solid #dbdbdb;
  background: #fff !important;
  color: #000 !important;
}
.comment-area-box .form-btns .btn {
  --bs-btn-line-height: 1.2 !important;
  font-size: 0.9rem !important;
  padding: 5px 20px;
  color: #fff;
  background: #133aa5;
  margin-right: 15px;
  border: none;
  cursor: pointer;
  font-family: "Noto Sans", sans-serif;
}

.comment-area-box.is-active {
  display: block;
}

.dropdown-list {
  display: block;
  border-radius: 5px;
  display: block;
  height: 30px;
  padding: 5px;
  border: 1px solid gray;
}

.dropdown-list.show {
  display: block;
}

.toggle-button {
  display: block;
  margin-bottom: 10px;
}

#right-side-panel {
  width: 20%;
  background: #fff;
  box-shadow: 0px 0px 4px #b2b2b2;
  padding: 10px;
}

#designlist {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 10px;
}
#designlist label {
  font-size: 14px;
  font-weight: bold;
}

#designlist li {
  list-style: none;
  margin: 10px;
  white-space: nowrap;
  border: 1px solid #dcd8d8;
  color: #222222;
  cursor: pointer;
  width: 100%;
  height: 100px;
  overflow: hidden;
}
#designlist li.active {
  border: 2px dashed var(--primaryColor);
}

@media screen and (min-width: 768px) {
  .toggle-button {
    display: none;
    /* Hide button for larger screens */
  }
  .mobile-close-btn {
    display: none;
  }
}
.dropdown-trigger {
  display: flex;
  position: relative;
  right: 0px;
  justify-content: end;
  align-items: end;
  text-align: end;
  width: 32px;
}

.select-container {
  padding: 10px;
}

@media screen and (max-width: 640px) {
  #chat-content-wrapper.hide {
    display: none;
  }
  .chat-history-list {
    width: auto;
  }
  .tabs-container.vertical .tab-content.active {
    width: calc(100% - 20px);
  }
  app-page-header .page-title {
    font-size: 0.9rem;
  }
  app-page-header .page-title .icon {
    font-size: 0.85rem;
  }
  app-page-header .pull-right > span:first-child {
    font-size: 0.75rem !important;
  }
  app-page-header .pull-right .radio-group .radio {
    min-width: 80px;
    margin: 0.15rem;
  }
  app-page-header .pull-right .radio-group .radio label {
    font-size: 0.75rem !important;
  }
  #chat-tools-wrapper #chat-tools {
    gap: 8px;
  }
  #chat-tools-wrapper #chat-tools li {
    font-size: 0.9rem !important;
  }
  .right-sidebar .tab-list li {
    width: 45px !important;
    padding: 8px 5px !important;
  }
}
@media screen and (min-width: 320px) and (max-width: 767px) {
  audio {
    width: 100% !important;
    max-width: 300px;
  }
  #expand-collapse {
    visibility: visible;
  }
  .select-container {
    padding: 0px 20px;
    position: absolute;
    right: 20px;
    top: 70px;
    background: #fff;
    /* width: 28%; */
    justify-content: center;
    align-items: center;
    height: 21vh;
    min-width: 148px;
  }
  .dropdown-list {
    margin: 10px;
  }
  .mobile-close-btn {
    display: block;
  }
  .hidemobileView {
    display: none;
  }
  #botWrapper.rightpanel-active #chat-content-wrapper {
    display: none !important;
  }
  #botWrapper.rightpanel-active #right-side-panel {
    width: 100%;
  }
  #botWrapper.leftpanel-active #chat-content-wrapper {
    display: none !important;
  }
  #botinput-wrapper {
    width: 100% !important;
    padding: 0 5px;
  }
  .chat-header {
    width: 100% !important;
    justify-content: center;
    padding: 0 5px;
  }
  #chat-list-content {
    padding: 1% 0%;
    width: 100%;
    margin-left: 0%;
    max-width: 100%;
  }
  #chat-list {
    width: 100%;
    padding: 0 5px;
  }
  #chat-content-wrapper header {
    padding: 0px 5px !important;
  }
  #designlist li {
    height: 150px !important;
  }
  .mobileBased-header-section {
    flex-direction: column;
    gap: 10px;
    padding: 10px;
  }
  .mobileBased-header-section .page-title {
    width: 100%;
  }
  .mobileBased-header-section .page-title .icon {
    font-size: 0.9rem;
    padding: 5px 0;
  }
  .mobileBased-header-section .pull-right {
    width: 100% !important;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  .tab-list li {
    min-width: 44px;
    min-height: 44px;
    padding: 10px;
  }
  #chat-message-enter-box {
    width: 100%;
    margin: 0 auto;
  }
  #chat-message-enter-box #chatForm {
    width: 100%;
  }
  #voice-message {
    width: 100% !important;
    margin-left: 0;
    padding: 5px 10px;
    font-size: 0.85rem;
  }
  app-page-header .pull-right {
    width: 100% !important;
    flex-direction: column;
    align-items: flex-start !important;
    gap: 10px;
    margin-top: 10px;
  }
  app-page-header .pull-right.mobile-header-section {
    width: 100% !important;
    flex-direction: column;
    align-items: flex-start !important;
  }
  app-page-header .pull-right > span {
    width: 100% !important;
    margin: 0 !important;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  app-page-header .pull-right > span.mobile-doc-title {
    margin: 0 !important;
    flex-direction: column;
    gap: 10px;
  }
  app-page-header .pull-right > span:first-child {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.85rem;
  }
  app-page-header .pull-right > span .mobile-title-text {
    white-space: normal !important;
    word-break: break-word;
    max-width: 100%;
  }
  app-page-header .pull-right .radio-group {
    width: 100% !important;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: flex-start;
  }
  app-page-header .pull-right .radio-group.mobile-radio-group {
    flex-direction: column;
    width: 100% !important;
  }
  app-page-header .pull-right .radio-group .radio {
    margin: 0.25rem;
    flex: 1;
    min-width: 100px;
  }
  app-page-header .pull-right .radio-group .radio label {
    font-size: 0.85rem;
    white-space: nowrap;
  }
  app-page-header .right-menu .tab-list {
    gap: 5px !important;
    flex-wrap: wrap;
  }
  app-page-header .right-menu .tab-list li {
    width: 35px !important;
    padding: 8px 5px !important;
    font-size: 0.9rem;
  }
  app-page-header .right-menu .tab-list li::before {
    content: none;
  }
  #botWrapper {
    padding: 0px 5px;
  }
  .bot-middle-content {
    min-width: 100% !important;
    width: 100%;
    padding: 0 5px;
  }
  #chat-message-enter-box {
    border-radius: 1rem;
    padding: 8px;
  }
  #chat-message-enter-box #chatForm {
    width: 100%;
  }
  #chat-tools-wrapper {
    padding: 8px 5px;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: center;
  }
  #chat-tools-wrapper #chat-tools {
    gap: 10px;
    right: 0;
    flex-wrap: wrap;
    justify-content: center;
  }
  #chat-tools-wrapper #chat-tools li {
    font-size: 1rem !important;
  }
  #chat-tools-wrapper #chat-tools .category-dropdown-wrapper {
    width: 100%;
    order: -1;
  }
  #chat-tools-wrapper #chat-tools .category-dropdown-wrapper ::ng-deep .p-dropdown {
    width: 100% !important;
    min-width: 100% !important;
  }
  .right-sidebar {
    right: -100%;
  }
  .right-sidebar.open {
    right: 0;
  }
  .right-sidebar .tab-list {
    flex-wrap: wrap;
    justify-content: center;
    padding: 10px 5px;
  }
  .right-sidebar .tab-list li {
    width: 50px !important;
    padding: 10px;
  }
  .right-sidebar .tab-content .tab-view .listing-data {
    padding-left: 0.25rem;
  }
  .ai-assist-popup .container {
    padding: 0.5rem;
  }
  .ai-assist-popup .row {
    flex-direction: column;
  }
  .ai-assist-popup .row .col-8,
  .ai-assist-popup .row .col-4 {
    width: 100% !important;
    max-width: 100% !important;
    padding: 0.5rem;
  }
  .ai-assist-popup .row .col-8 {
    order: 2;
  }
  .ai-assist-popup .row .col-4 {
    order: 1;
  }
  .ai-assist-popup .card {
    height: auto !important;
    max-height: calc(100vh - 100px);
  }
  .ai-assist-popup .pop-content {
    height: calc(100vh - 300px) !important;
    max-height: 400px;
  }
  .ai-assist-popup .list-wrapper.list-overflow {
    height: calc(100vh - 200px) !important;
    max-height: 300px;
  }
  .policy-upload .modal-dialog {
    margin: 10px auto;
    max-width: 600px;
    max-height: 90vh;
    display: flex;
    align-items: center;
    min-height: 0;
  }
  .policy-upload .modal-dialog .modal-content {
    max-width: 100%;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .policy-upload .modal-dialog .modal-header {
    flex-shrink: 0;
  }
  .policy-upload .modal-dialog .modal-body {
    max-height: calc(90vh - 120px);
    padding: 15px;
    overflow-y: auto;
    overflow-x: hidden;
    flex: 1;
    min-height: 0;
  }
  .policy-upload .modal-dialog .modal-footer {
    flex-shrink: 0;
  }
  .policy-upload .row .col-5,
  .policy-upload .row .col-6,
  .policy-upload .row .col-7 {
    width: 100% !important;
    max-width: 100% !important;
    padding: 0.5rem 0;
  }
}
@media screen and (min-width: 320px) and (max-width: 767px) and (max-width: 768px) {
  .policy-upload .modal-dialog {
    margin: 10px;
    max-width: calc(100% - 20px);
    max-height: 95vh;
  }
  .policy-upload .modal-dialog .modal-content {
    max-height: 95vh;
  }
  .policy-upload .modal-dialog .modal-body {
    max-height: calc(95vh - 120px);
  }
}
@media screen and (min-width: 320px) and (max-width: 767px) {
  p.disclaimer {
    font-size: 0.7rem !important;
    padding: 5px !important;
  }
  p.disclaimer span {
    font-size: 0.7rem !important;
  }
  p.disclaimer span ::ng-deep b {
    font-size: 0.75rem !important;
  }
  #chat-list-content {
    max-height: calc(100vh - 250px) !important;
    min-height: calc(100vh - 250px) !important;
    padding: 0 5px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .question {
    margin-left: 5px !important;
    margin-right: 5px !important;
    padding: 10px !important;
    font-size: 0.9rem !important;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  .question::before {
    left: -15px !important;
    border-width: 15px !important;
  }
  .answer {
    margin-left: 5px !important;
    margin-right: 5px !important;
    padding: 10px !important;
    font-size: 0.9rem !important;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  .answer .answer-content::before {
    left: -25px !important;
    border-width: 15px !important;
  }
  #botWrapper {
    padding: 0;
  }
  .right-sidebar {
    width: 100% !important;
    max-width: 100%;
  }
  .right-sidebar .tab-content {
    padding: 10px 5px;
  }
  .right-sidebar .listing-data {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .ai-assist-popup .container {
    padding: 0.5rem;
  }
  .ai-assist-popup .row {
    margin: 0;
  }
  .ai-assist-popup .col-8, .ai-assist-popup .col-4 {
    padding: 0.5rem;
  }
  .policy-upload .modal-dialog {
    margin: 10px;
    max-width: calc(100% - 20px);
  }
  .policy-upload .modal-body {
    padding: 15px 10px;
    max-height: calc(100vh - 200px);
    overflow-y: auto;
  }
  #chat-tools-wrapper {
    padding: 8px;
    flex-wrap: wrap;
  }
  #chat-tools-wrapper #chat-tools {
    gap: 12px;
    flex-wrap: wrap;
    justify-content: center;
  }
  #chat-tools-wrapper #chat-tools li {
    min-width: 44px;
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
@media screen and (max-width: 480px) {
  app-page-header .pull-right .radio-group {
    flex-direction: column;
    width: 100%;
    gap: 8px;
  }
  app-page-header .pull-right .radio-group .radio {
    width: 100%;
    min-width: 100%;
    margin: 0.25rem 0;
  }
  app-page-header .pull-right .radio-group .radio label {
    font-size: 0.8rem;
    padding: 8px;
  }
  app-page-header .right-menu .tab-list {
    width: 100%;
    justify-content: space-around;
    gap: 5px;
  }
  app-page-header .right-menu .tab-list li {
    flex: 1;
    max-width: 60px;
    min-width: 44px;
    min-height: 44px;
  }
  app-page-header .page-title {
    font-size: 0.85rem;
  }
  app-page-header .page-title .icon {
    font-size: 0.8rem;
  }
  #chat-tools-wrapper {
    padding: 5px;
  }
  #chat-tools-wrapper #chat-tools {
    flex-direction: row;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    justify-content: center;
  }
  #chat-tools-wrapper #chat-tools .category-dropdown-wrapper {
    width: 100%;
    order: -1;
    margin-bottom: 5px;
  }
  #chat-tools-wrapper #chat-tools .category-dropdown-wrapper ::ng-deep .p-dropdown {
    width: 100% !important;
  }
  #chat-tools-wrapper #chat-tools li {
    min-width: 44px;
    min-height: 44px;
    flex: 0 0 auto;
    justify-content: center;
    padding: 8px;
  }
  .ai-assist-popup {
    padding: 0.5rem;
  }
  .ai-assist-popup .pop-content {
    height: calc(100vh - 280px) !important;
    max-height: 300px;
    padding: 10px;
    font-size: 0.85rem;
  }
  .ai-assist-popup .list-wrapper.list-overflow {
    height: calc(100vh - 180px) !important;
    max-height: 250px;
  }
  .ai-assist-popup .pop-header {
    padding: 10px !important;
    font-size: 0.9rem;
  }
  .ai-assist-popup .card-content {
    padding: 10px !important;
  }
  .policy-upload .modal-dialog {
    margin: 5px;
    max-width: calc(100% - 10px);
  }
  .policy-upload .modal-body {
    padding: 10px 5px;
    font-size: 0.85rem;
  }
  .policy-upload .modal-footer {
    padding: 10px;
    flex-direction: column;
    gap: 8px;
  }
  .policy-upload .modal-footer button {
    width: 100%;
    margin: 0;
  }
  .question,
  .answer {
    margin-left: 5px !important;
    margin-right: 5px !important;
    padding: 8px !important;
    font-size: 0.85rem !important;
    line-height: 1.4;
  }
  #chat-list-content {
    max-height: calc(100vh - 280px) !important;
    min-height: calc(100vh - 280px) !important;
  }
  #chat-message-enter-box {
    border-radius: 1.5rem;
    padding: 5px;
  }
  #chat-message-enter-box #chatForm {
    padding: 5px;
  }
  p.disclaimer {
    font-size: 0.65rem !important;
    padding: 5px !important;
    line-height: 1.3;
  }
  .right-sidebar .tab-list {
    padding: 5px;
  }
  .right-sidebar .tab-list li {
    padding: 8px 5px;
    font-size: 0.9rem;
  }
  .history-item,
  .pin-item,
  .file-item,
  .audio-item {
    padding: 10px 5px;
    font-size: 0.85rem;
  }
  .audio-wrapper {
    width: 100% !important;
    max-width: 100%;
    right: 0;
    left: 0;
    padding: 10px;
  }
  .audio-wrapper audio {
    width: 100% !important;
  }
}
@media screen and (min-width: 641px) and (max-width: 960px) {
  .bot-middle-content {
    min-width: 100% !important;
    max-width: 100%;
    padding: 0 15px;
  }
  #chat-list-content {
    max-width: 100%;
    padding: 0 10px;
    max-height: calc(100vh - 200px) !important;
    min-height: calc(100vh - 200px) !important;
  }
  app-page-header .pull-right {
    width: auto !important;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
  }
  app-page-header .pull-right > span {
    width: auto !important;
  }
  app-page-header .pull-right .radio-group {
    width: auto !important;
    flex-wrap: wrap;
  }
  .ai-assist-popup .row {
    flex-direction: row;
  }
  .ai-assist-popup .row .col-8 {
    width: 60% !important;
  }
  .ai-assist-popup .row .col-4 {
    width: 40% !important;
  }
  #chat-message-enter-box {
    width: 100%;
    padding: 10px;
  }
  #chat-tools-wrapper {
    padding: 10px;
  }
  #chat-tools-wrapper #chat-tools {
    gap: 15px;
  }
  .question,
  .answer {
    margin-left: 15px;
    padding: 12px;
    font-size: 0.95rem;
  }
}
#botinput-wrapper {
  width: 100%;
}
#botinput-wrapper p.disclaimer {
  color: var(--textsecondarycolor) !important;
  padding: 0px;
  margin-top: 6px;
}
#botinput-wrapper p.disclaimer span {
  display: inline-block;
  text-align: center;
  color: var(--textsecondarycolor) !important;
}
#botinput-wrapper p.disclaimer span ::ng-deep b {
  font-size: 0.9rem !important;
}
#botinput-wrapper p.disclaimer span span {
  font-size: 0.75rem;
}
#botinput-wrapper p.disclaimer .expan-down-arrow {
  display: flex;
  justify-content: center;
}
#botinput-wrapper p.disclaimer .expan-down-arrow a {
  background-color: #fff;
  padding: 7px;
}
#botinput-wrapper p.disclaimer .expan-down-arrow a .fa {
  font-size: 1.5rem !important;
}

.bot-middle-content {
  width: 100%;
  max-width: 960px;
  margin: auto;
  min-width: 840px;
}
@media screen and (max-width: 840px) {
  .bot-middle-content {
    min-width: 100%;
    padding: 0 10px;
  }
}

#template-title {
  display: inline-flex;
  width: 100%;
  font-size: 1rem;
}
#template-title span:nth-child(1) {
  width: 80%;
  text-align: center;
}
#template-title span:nth-child(2) {
  width: 20%;
}
#template-title .button {
  border-color: #fff;
  border-width: 0px;
}

#designlist-wrapper {
  height: 90vh;
  overflow-y: auto;
  padding: 0px 20px;
}

@media screen and (max-width: 640px) {
  .chat-history-list {
    left: 0px;
    top: 0px;
  }
}
@media screen and (min-width: 768px) and (max-width: 960px) {
  #chat-list-content {
    padding: 1% 3% 0% 1% !important;
  }
}
.checkbox-wrapper .tgl {
  display: none;
}

.checkbox-wrapper .tgl,
.checkbox-wrapper .tgl:after,
.checkbox-wrapper .tgl:before,
.checkbox-wrapper .tgl *,
.checkbox-wrapper .tgl *:after,
.checkbox-wrapper .tgl *:before,
.checkbox-wrapper .tgl + .tgl-btn {
  box-sizing: border-box;
}

.checkbox-wrapper .tgl::-moz-selection,
.checkbox-wrapper .tgl:after::-moz-selection,
.checkbox-wrapper .tgl:before::-moz-selection,
.checkbox-wrapper .tgl *::-moz-selection,
.checkbox-wrapper .tgl *:after::-moz-selection,
.checkbox-wrapper .tgl *:before::-moz-selection,
.checkbox-wrapper .tgl + .tgl-btn::-moz-selection,
.checkbox-wrapper .tgl::selection,
.checkbox-wrapper .tgl:after::selection,
.checkbox-wrapper .tgl:before::selection,
.checkbox-wrapper .tgl *::selection,
.checkbox-wrapper .tgl *:after::selection,
.checkbox-wrapper .tgl *:before::selection,
.checkbox-wrapper .tgl + .tgl-btn::selection {
  background: none;
}

.checkbox-wrapper .tgl + .tgl-btn {
  outline: 0;
  display: block;
  width: 2.7em;
  height: 1.4em;
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}

.checkbox-wrapper .tgl + .tgl-btn:after,
.checkbox-wrapper .tgl + .tgl-btn:before {
  position: relative;
  display: block;
  content: "";
  width: 50%;
  height: 100%;
}

.checkbox-wrapper .tgl + .tgl-btn:after {
  left: 0;
}

.checkbox-wrapper .tgl + .tgl-btn:before {
  display: none;
}

.checkbox-wrapper .tgl:checked + .tgl-btn:after {
  left: 50%;
}

.checkbox-wrapper .tgl-light + .tgl-btn {
  background: #b1b1b1;
  border-radius: 2em;
  padding: 2px;
  transition: all 0.4s ease;
}

.checkbox-wrapper .tgl-light + .tgl-btn:after {
  border-radius: 50%;
  background: #fff;
  transition: all 0.2s ease;
}

.checkbox-wrapper .tgl-light:checked + .tgl-btn {
  background: var(--primaryColor) !important;
}

.modal-dialog .modal-content {
  max-width: calc(100vw - 50px);
}
.modal-dialog .modal-header {
  justify-content: space-between;
}
.modal-dialog .modal-body {
  max-height: calc(100vh - 150px);
  overflow-y: auto;
  scrollbar-width: none;
}
.modal-dialog .fa-solid {
  font-size: 1.5rem !important;
  color: #fff !important;
}
.modal-dialog .btn-primary {
  background: var(--primaryColor) !important;
  color: #fff !important;
}
.modal-dialog .btn-cancel {
  background-color: #eee;
  color: #111;
}
.modal-dialog .btn {
  padding: 0.3rem 0.8rem !important;
}

.modal.fade {
  background: rgba(0, 0, 0, 0.2);
}

.modal.show {
  display: block;
}

.modal-header {
  background: var(--primaryColor);
  color: #fff;
}

#scroll-top-button {
  position: fixed;
  bottom: 6px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  right: 5px;
  align-items: center;
  display: flex;
  justify-content: center;
  background: #fff;
  box-shadow: 0 0 5px 2px #ddd;
}
#scroll-top-button .fa-arrow-up {
  font-size: 1.5rem !important;
}

ul.ai-tools-menu {
  display: inline;
  padding: 0px;
  margin: 0px;
}
ul.ai-tools-menu li {
  display: inline-flex;
  align-items: center;
  margin-right: 15px;
  cursor: pointer;
}
ul.ai-tools-menu li span {
  padding: 10px 10px 10px 3px;
  color: #222222;
  font-size: 0.9rem;
}
ul.ai-tools-menu li .fa {
  font-size: 0.9rem !important;
}
ul.ai-tools-menu li.active {
  color: var(--primaryColor);
}
ul.ai-tools-menu li.active i {
  color: var(--menuSelectColor) !important;
}

.custom-radios form {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}
.custom-radios label {
  display: inline-flex;
  cursor: pointer;
  font-weight: 500;
  position: relative;
  overflow: hidden;
  margin-bottom: 0.375em;
  /* Accessible outline */
  /* Remove comment to use */
  /*
          &:focus-within {
                  outline: .125em solid \$primary-color;
          }
      */
}
.custom-radios label input {
  position: absolute;
  left: -9999px;
}
.custom-radios label input:checked + span {
  background-color: hsla(var(--primaryColor), 84%);
}
.custom-radios label input:checked + span:before {
  box-shadow: inset 0 0 0 0.4375em var(--primaryColor);
}
.custom-radios label span {
  display: flex;
  align-items: center;
  padding: 0.375em 0.75em 0.375em 0.375em;
  border-radius: 99em;
  transition: 0.25s ease;
  font-size: 0.9rem;
  font-weight: bold;
  color: #666;
}
.custom-radios label span:before {
  display: flex;
  flex-shrink: 0;
  content: "";
  background-color: #fff;
  width: 1.5em;
  height: 1.5em;
  border-radius: 50%;
  margin-right: 0.375em;
  transition: 0.25s ease;
  box-shadow: inset 0 0 0 0.125em var(--primaryColor);
}

.radio-wrapper {
  padding-right: 1.5rem;
}

.right-sidebar {
  position: fixed;
  top: 0;
  right: -285px;
  width: 285px;
  height: 100%;
  background: #fff;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
  transition: right 0.3s ease;
  z-index: 1000;
}
@media screen and (max-width: 767px) {
  .right-sidebar {
    width: 100%;
    max-width: 100%;
    right: -100%;
  }
}

.right-sidebar.open {
  right: 0;
}
@media screen and (max-width: 767px) {
  .right-sidebar.open {
    right: 0;
  }
}

.icon-btn {
  cursor: pointer;
  border: none;
  background: none;
  font-size: 24px;
  line-height: 1px;
  color: #fff;
}
.icon-btn:hover {
  color: #1571b9;
}

.close-btn {
  position: absolute;
  top: 0.3rem;
  right: 0.5rem;
  font-size: 1.7rem;
  font-weight: 600;
  background: transparent;
  border: none;
  font-size: 24px;
  cursor: pointer;
  min-width: 44px;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
}
.close-btn:hover {
  color: #1571b9;
}
@media screen and (max-width: 767px) {
  .close-btn {
    font-size: 20px;
    top: 0.5rem;
    right: 0.5rem;
  }
}

.tab-list {
  list-style: none;
  display: flex;
  padding: 0;
}

.tab-list li {
  padding: 13px 10px;
  cursor: pointer;
  border: 1px solid transparent;
  border-bottom: none;
  width: 40px;
  text-align: center;
}
.tab-list li:hover {
  background-color: rgba(134, 183, 255, 0.9882352941);
  color: #fff !important;
}
.tab-list li:hover .fa, .tab-list li:hover .fa-solid {
  color: var(--icondarkcolor) !important;
}

.tab-list li.active {
  border: 1px solid #1571b9;
  border-bottom: 1px solid #1571b9;
  background-color: #1571b9;
  color: #fff;
}
.tab-list li.active i.fa {
  color: #fff !important;
}

.tab-content {
  padding: 10px 0;
}
.tab-content .tab-view {
  width: 100%;
}
.tab-content .tab-view ul li:hover {
  background-color: rgba(21, 113, 185, 0.1607843137);
  color: #1571b9;
}
.tab-content .tab-view ul li label {
  white-space: nowrap;
  width: 78%;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
.tab-content .tab-view ul li label .fa {
  line-height: 26px;
  margin-right: 10px;
}

.history-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  border-bottom: 1px solid #eee;
}

.history-item.odd {
  background-color: #f9f9f9;
}

.history-label {
  cursor: pointer;
  flex: 1;
}

.history-delete {
  color: #d9534f;
  cursor: pointer;
  margin-left: 10px;
}

.pin-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  border-bottom: 1px solid #e0e0e0;
}

.pin-item.odd {
  background-color: #f9f9f9;
}

.pin-label {
  cursor: pointer;
  flex: 1;
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
}

.pin-delete, .history-delete {
  cursor: pointer;
  padding-left: 10px;
  font-size: 1rem;
}
.pin-delete .pi-trash, .history-delete .pi-trash {
  color: #c10909 !important;
}

.file-item {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  border-bottom: 1px solid #ddd;
}

.file-item.odd {
  background-color: #f9f9f9;
}

.file-label {
  flex: 1;
  cursor: pointer;
  font-weight: 500;
  color: #333;
}

.file-date {
  font-size: 12px;
  color: #999;
}

.file-actions {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-left: 10px;
}

.action-icon {
  color: #007bff;
  cursor: pointer;
  font-size: 1rem;
}

.action-icon:hover {
  color: #0056b3;
}

.audio-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 10px;
  border-bottom: 1px solid #eee;
  position: relative;
}

.audio-item.odd {
  background-color: #f9f9f9;
}

.audio-info {
  flex: 1;
  cursor: pointer;
}

.audio-label {
  font-weight: 500;
  color: #333;
}

.audio-date {
  font-size: 12px;
  color: #999;
}

.audio-player-wrapper {
  margin-left: 10px;
  position: relative;
}

.audio-play-icon {
  font-size: 20px;
  color: #007bff;
  cursor: pointer;
}

.audio-wrapper {
  position: absolute;
  right: 0;
  top: 30px;
  z-index: 10;
  background: #333;
  padding: 10px;
  border-radius: 8px;
}

.audio-wrapper.hide {
  display: none;
}

.close-audio {
  color: #fff;
  float: right;
  cursor: pointer;
  font-size: 16px;
  margin-bottom: 5px;
}

.audio-actions {
  margin-left: 10px;
}

.action-icon {
  font-size: 16px;
  color: #007bff;
  cursor: pointer;
}

.action-icon:hover {
  color: #0056b3;
}

.notification-list {
  margin-left: 0px !important;
  margin-top: 0px !important;
}
.notification-list li {
  margin-top: 0px !important;
}
.notification-list .file-item.active {
  background: #f4f4f4 !important;
}
.notification-list .file-item.active .file-label {
  color: var(--textsecondarycolor) !important;
}
.notification-list li {
  list-style: none !important;
}
.notification-list li:hover {
  background: #f0f0f0 !important;
}
.notification-list li:hover .fa, .notification-list li:hover .fa-solid {
  color: var(--icondarkcolor) !important;
}
.notification-list label.file-label {
  width: 100% !important;
  max-width: 90% !important;
}

.pagination {
  padding-top: 5px !important;
}

.fa-microphone-slash.inactive {
  pointer-events: none !important;
}

.ai-assist-popup .doc-views-tabs {
  border-bottom-width: 0px !important;
}
.ai-assist-popup .pop-header {
  background: var(--primaryColor);
  color: #fff;
}
.ai-assist-popup .pop-header .fa-solid, .ai-assist-popup .pop-header .fa {
  color: #fff !important;
}
.ai-assist-popup .card-content .file-item {
  border-bottom: 0px !important;
}
.ai-assist-popup .pop-content {
  height: calc(100vh - 200px);
  overflow-y: auto;
  width: 100%;
  scrollbar-width: 3px;
  color: var(--textsecondarycolor) !important;
}
.ai-assist-popup .pop-title {
  text-align: center;
  margin-left: 50px;
  width: 75%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ai-assist-popup .content-tab .level-left {
  width: 100% !important;
  border: 1px solid #81c2fb;
  border-radius: 5px;
  background: #fff !important;
  border-radius: 100px !important;
}
.ai-assist-popup .content-tab .level-left .level-item {
  width: 90%;
  justify-content: start;
}
.ai-assist-popup .content-tab .level-left .level-item.input-search-box .field, .ai-assist-popup .content-tab .level-left .level-item.input-search-box .control, .ai-assist-popup .content-tab .level-left .level-item.input-search-box .input {
  width: 100%;
}
.ai-assist-popup .list-wrapper.list-overflow {
  height: calc(100vh - 160px);
}
.ai-assist-popup .card {
  height: calc(100vh - 70px);
  overflow-y: auto;
}
.ai-assist-popup .pagination {
  position: absolute;
  width: 95%;
  bottom: 10px;
}
.ai-assist-popup .menu-options.level {
  background: #c2eefb !important;
}

#suggestion-list {
  width: inherit;
  font-size: 0.9rem !important;
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 2px 2px, rgba(0, 0, 0, 0.09) 0px 2px 4px, rgba(0, 0, 0, 0.09) 0px 2px 8px, rgba(0, 0, 0, 0.09) 0px 2px 5px;
  max-height: 200px;
  overflow-y: auto;
  position: absolute;
  z-index: 99;
  top: 43px;
}
#suggestion-list p {
  padding: 10px;
}

::ng-deep .p-multiselect {
  min-width: 15rem;
  width: 90px !important;
}
::ng-deep .p-multiselect .p-multiselect-header {
  display: none;
}

::ng-deep .p-inputwrapper.p-disabled {
  background: #eee !important;
}

::ng-deep .p-multiselect.p-inputwrapper {
  border: 1px solid #c8c8c8;
  padding: 5px;
}

::ng-deep .p-multiselect-items-wrapper {
  background: #fff;
  border: 1px solid #c8c8c8;
  padding: 5px;
}
::ng-deep .p-multiselect-items-wrapper .p-checkbox-box {
  border: 1px solid var(--primaryColor);
  width: 20px;
  height: 20px;
}

::ng-deep .p-inputwrapper.p-disabled {
  background: #eee !important;
}

::ng-deep .p-multiselect.p-inputwrapper {
  border: 1px solid #c8c8c8;
  padding: 5px;
}

::ng-deep .p-multiselect-items-wrapper {
  background: #fff;
  border: 1px solid #c8c8c8;
  padding: 5px;
}
::ng-deep .p-multiselect-items-wrapper .p-checkbox-box {
  border: 1px solid var(--primaryColor);
  width: 20px;
  height: 20px;
}

span.inactive ::ng-deep .p-dropdown {
  border: 1px solid red !important;
}

::ng-deep .p-dropdown {
  min-width: 15rem;
  width: 90px !important;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
}
::ng-deep .p-dropdown .p-dropdown-items {
  background: #fff;
  border: 1px solid #dcdcdc;
  border-radius: 5px;
}
::ng-deep .p-dropdown .p-dropdown-items li {
  padding: 5px;
}
::ng-deep .p-dropdown .p-dropdown-items li span {
  text-transform: capitalize;
}
::ng-deep .p-dropdown .p-dropdown-items li:hover {
  background: #f4f4f4 !important;
  color: #171717;
}
::ng-deep .p-dropdown .p-dropdown-items li[aria-selected=true] {
  background: #eee !important;
}

.category-dropdown-wrapper {
  display: flex;
  align-items: center;
  padding: 0 5px;
}

.dropdown-trigger {
  display: none;
}

.policy-upload .profile-img {
  margin: 5px;
  width: auto !important;
}
.policy-upload .profile-img .img-options {
  padding-top: 0px;
}
.policy-upload .modal-body {
  min-height: 315px;
}
.policy-upload .file-cta {
  background: var(--primaryColor);
}
.policy-upload .file-cta .pi {
  font-size: 1.3rem;
  color: #fff !important;
}

.radio-group {
  width: 250px !important;
}

.radio {
  margin: 0.5rem;
}
.radio input[type=radio] {
  position: absolute;
  opacity: 0;
}
.radio input[type=radio] + .radio-label:before {
  content: "";
  background: #f4f4f4;
  border-radius: 100%;
  border: 1px solid #b4b4b4;
  display: inline-block;
  width: 1.4em;
  height: 1.4em;
  position: relative;
  top: -0.1em;
  margin-right: 0.5em;
  vertical-align: top;
  cursor: pointer;
  text-align: center;
  transition: all 250ms ease;
}
.radio input[type=radio]:checked + .radio-label:before {
  background-color: #3197EE;
  box-shadow: inset 0 0 0 4px #f4f4f4;
}
.radio input[type=radio]:focus + .radio-label:before {
  outline: none;
  border-color: #3197EE;
}
.radio input[type=radio]:disabled + .radio-label:before {
  box-shadow: inset 0 0 0 4px #f4f4f4;
  border-color: #b4b4b4;
  background: #b4b4b4;
}
.radio input[type=radio] + .radio-label:empty:before {
  margin-right: 0;
}

.icon {
  cursor: pointer;
}

.mobileBased-header-section {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px;
}
@media screen and (max-width: 480px) {
  .mobileBased-header-section {
    flex-direction: column;
    padding: 8px;
  }
}

.dropzone-upload-wrapper .dropzone {
  border: 2px dashed #ccc;
  border-radius: 0.5rem;
  text-align: center;
  padding: 2rem 1.5rem;
  transition: all 0.3s ease;
  cursor: pointer;
  background: #fff;
  position: relative;
  margin-bottom: 1rem;
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dropzone-upload-wrapper .dropzone.dragging {
  background: #f0f8ff;
  border-color: #1571b9;
}
.dropzone-upload-wrapper .dropzone.has-file {
  border-color: #ddd;
  background: #fafafa;
}
.dropzone-upload-wrapper .dropzone:hover:not(.has-file) {
  border-color: #999;
  background: #f9f9f9;
}
.dropzone-upload-wrapper .dropzone input[type=file] {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
.dropzone-upload-wrapper .dropzone .dropzone-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  color: #444;
  pointer-events: none;
}
.dropzone-upload-wrapper .dropzone .dropzone-label .icon {
  font-size: 2.5rem;
  color: #1571b9;
  margin-bottom: 0.25rem;
}
.dropzone-upload-wrapper .dropzone .dropzone-label .text {
  font-size: 0.95rem;
  color: #333;
}
.dropzone-upload-wrapper .dropzone .dropzone-label .text strong {
  display: block;
  margin-bottom: 0.25rem;
}
.dropzone-upload-wrapper .dropzone .dropzone-label small {
  color: #777;
  font-size: 0.85rem;
  margin-top: 0.25rem;
}
.dropzone-upload-wrapper .selected-file-display {
  margin-top: 1rem;
}
.dropzone-upload-wrapper .selected-file-display .file-item-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.25rem;
  background: #fff;
  border-radius: 0.5rem;
  border: 1px solid #e0e0e0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: all 0.2s;
}
.dropzone-upload-wrapper .selected-file-display .file-item-card:hover {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}
.dropzone-upload-wrapper .selected-file-display .file-item-card .file-icon-wrapper {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
}
.dropzone-upload-wrapper .selected-file-display .file-item-card .file-icon-wrapper i {
  font-size: 2rem;
  color: #1571b9;
}
.dropzone-upload-wrapper .selected-file-display .file-item-card .file-details {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.dropzone-upload-wrapper .selected-file-display .file-item-card .file-details .selected-file-name {
  font-weight: 400;
  color: #333;
  margin: 0;
  word-break: break-word;
  font-size: 0.95rem;
  line-height: 1.4;
}
.dropzone-upload-wrapper .selected-file-display .file-item-card .file-details .file-size-text {
  color: #666;
  font-size: 0.875rem;
  margin: 0;
}
.dropzone-upload-wrapper .selected-file-display .file-item-card .delete-btn {
  flex-shrink: 0;
  border: none;
  background: transparent;
  color: #999;
  cursor: pointer;
  font-size: 1.25rem;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  transition: all 0.2s;
  width: 32px;
  height: 32px;
}
.dropzone-upload-wrapper .selected-file-display .file-item-card .delete-btn:hover {
  color: #666;
  background: #f5f5f5;
}`, "",{"version":3,"sources":["webpack://./src/app/components/ai-assist/ai-assist.component.scss"],"names":[],"mappings":"AAKA;EACE,aAAA;EACA,gBAAA;AAJF;;AAMA;EACE,aAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,2BAAA;AAHF;;AAQA;EACE,6BAAA;AALF;;AAQA;EACE,kCAAA;EACA,0BAAA;EACA,2BAAA;AALF;;AAQA;EACE,2BAAA;EACA,uBAAA;AALF;;AAQA;EACE,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;AALF;;AAQA;;EAEE,WAAA;EACA,aAAA;EACA,iBAAA;AALF;;AAWE;;EACE,+CAAA;AAPJ;AASI;;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AANN;AAUI;;EACE,mBAAA;AAPN;;AAeI;EAEE,SAAA;AAbN;;AAkBA;EACE,UAAA;EACA,6BAAA;AAfF;;AAkBA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,wBAAA;AAfF;;AAkBA;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,gDAAA;AAfF;;AAmBA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;AAhBF;;AAmBA;EACE,aAAA;AAhBF;;AAmBA;EACE,eAAA;AAhBF;;AAmBA;EACE,kBAAA;EACA,gBAAA;EACA,UAAA;AAhBF;;AAmBA;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gDAAA;EACA,gCAAA;AAhBF;;AAmBA;EACE,sBAAA;EACA,oCAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,6BAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAhBF;;AAmBA;EACE,aAAA;EAEA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,QAAA;AAjBF;AAmBE;EACE,iDAAA;AAjBJ;AAoBE;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,oBAAA;AAlBJ;AAsBE;EACE,aAAA;AApBJ;AAuBE;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,8BAAA;AArBJ;AA8BE;EAEE,cAAA;AA7BJ;;AA+CC;EACC,uBAAA;EACA,2CAAA;EACA,6BAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;EACA,iCAAA;EACA,yCAAA;EACA,eAAA;AA5CF;AA8CE;EACE,aAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;AA5CJ;AA8CI;EACE,kBAAA;EACA,aAAA;EACA,cAAA;AA5CN;AAgDE;EACG,gCAAA;AA9CL;AAiDE;EACE,0BAAA;EACA,oBAAA;AA/CJ;AAkDE;EACE,aAAA;AAhDJ;AAmDE;EACE,uBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iCAAA;EACA,gFAAA;EAEA,eAAA;EACA,kEAAA;EACA,qBAAA;EACA,wBAAA;EACA,UAAA;AAlDJ;AAoDI;EAdF;IAeI,2CAAA;IACA,UAAA;EAjDJ;AACF;AAoDE;EACE,cAAA;EACA,wBAAA;AAlDJ;AAqDE;EACE,wBAAA;EACA,iCAAA;EACA,aAAA;AAnDJ;AAqDI;EACE,WAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;AAnDN;AAuDI;EACE,aAAA;AArDN;AAwDI;EAEC,yBAAA;AAvDL;AAwDM;EACE,UAAA;AAtDR;AA0DI;EAEE,yBAAA;EACA,gCAAA;AAzDN;;AA8DA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;AA3DF;;AA8DA;EACE,WAAA;EACA,gBAAA;AA3DF;;AA8DA;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AA3DF;AA6DE;EACE,oBAAA;EACA,6BAAA;EACA,qBAAA;EACA,sDAAA;EACA,sBAAA;AA3DJ;AA8DI;EACE,qBAAA;EAGA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;AA9DN;AAiEI;EACE,aAAA;EACA,qBAAA;EACA,SAAA;EACA,gBAAA;AA/DN;;AAoEA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,4BAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;AAjEF;;AAoEA;;;;;;;;;;;;;;;;;;;;GAAA;AAqBA;EAGE,WAAA;EACA,qBAAA;EAGA,iBAAA;EAIA,kBAAA;EAEA,wBAAA;EACA,gBAAA;EACA,qBAAA;EACA,YAAA;AAzEF;;AA6EA;EACE,aAAA;AA1EF;;AA6EA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AA1EF;;AA+EA;EAEE,mBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,mBAAA;EACA,mBAAA;EAGA,UAAA;EACC,yBAAA;AA/EH;AAiFG;EAdH;IAeK,qBAAA;IACA,YAAA;EA9EH;AACF;AAgFE;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,WAAA;AA9EJ;AAgFI;EANF;IAOI,YAAA;EA7EJ;AACF;AAgFE;EACE,sBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;AA9EJ;AAgFI;EATF;IAUI,YAAA;IACA,iBAAA;IACA,YAAA;EA7EJ;AACF;AA+EI;EAfF;IAgBI,YAAA;IACA,kBAAA;IACA,YAAA;EA5EJ;AACF;AA+EE;EACE,qBAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;AA7EJ;AA+EI;EATF;IAUI,YAAA;IACA,iBAAA;IACA,gBAAA;EA5EJ;AACF;AA8EI;EAfF;IAgBI,YAAA;IACA,kBAAA;IACA,gBAAA;EA3EJ;AACF;;AA+EA;;;;;;;;GAAA;AAUA;;EAEE,cAAA;EACA,eAAA;EACA,0BAAA;AA7EF;;AAgFA;;EAEE,uBAAA;AA7EF;;AAgFA;EACE,oCAAA;AA7EF;;AAgFA;EACE,mBAAA;EACA,2BAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,kCAAA;EACA,uDAAA;EACA,wDAAA;AA7EF;;AAgFA;EACE,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,yDAAA;EACA,gEAAA;EACA,8DAAA;AA7EF;;AAiFA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AA9EF;;AAiFA;EACE,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,yDAAA;AA9EF;;AAkFA;EACE,gBAAA;AA/EF;;AAkFA;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EAEA,kDAAA;AAhFF;AAiFE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;AA/EJ;AAkFE;EACE,eAAA;AAhFJ;AAmFE;EACE,kBAAA;AAjFJ;AAmFI;EACE,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EAEA;;oCAAA;AAhFN;AAmFM;EACE,4BAAA;EACA,qBAAA;EACA,eAAA;EACA;;aAAA;AA/ER;AAqFQ;EACE,cAAA;AAnFV;AAwFI;EACE,cAAA;AAtFN;AAyFI;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;AAvFN;;AA8FA;EACE,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,sDAAA;AA3FF;;AA8FA;EACE,kBAAA;EACA,gBAAA;AA3FF;AA6FE;EACE,aAAA;AA3FJ;;AA+FA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AA5FF;AA8FE;EACE,mBAAA;AA5FJ;;AAgGA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,cA/qBc;EAgrBd,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;AA7FF;;AAiGA;EACE,UAAA;EACA,eAAA;AA9FF;;AAkGA;EACE,UAAA;EACA,eAAA;EACA,iBAAA;AA/FF;;AAmGA;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;AAhGF;AAkGE;EACE,gBAAA;EACA,YAAA;AAhGJ;AAmGE;EACE,2BAAA;EACA,yCAAA;EACA,yBAAA;AAjGJ;;AAsGA;EACE,kBAAA;EAEA,YAAA;AApGF;AAsGE;EACE,gBAAA;EACA,YAAA;AApGJ;AAuGE;EACE,2BAAA;EACA,uCAAA;EACA,yBAAA;AArGJ;;AA0GA;EACE,UAAA;AAvGF;;AA0GA,UAAA;AACA;EACE,gBAAA;AAvGF;;AA0GA,WAAA;AACA;EACE,gBAAA;AAvGF;;AA0GA,oBAAA;AACA;EACE,gBAAA;AAvGF;;AA+GE;EACE,kCAAA;EACA,uBAAA;AA5GJ;;AAiHA;EACE,qBAAA;EACA,kBAAA;EAEA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;AA/GF;AAiHE;EACE,qBAAA;EACA,cAAA;AA/GJ;;AAmHA;EACE,aAAA;EACA,WAAA;EACA,oBAAA;EAEA,aAAA;EAEA,gCAAA;EACD,+BAAA;AAlHD;AAoHC;EAVD;IAWG,uBAAA;IACA,YAAA;IACA,kCAAA;IACA,iCAAA;EAjHD;AACF;;AAmHA;EACE,aAAA;EACA,qBAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EA6HA,oBAAA;AA5OF;AAkHA;EACE,aAAA;EACA,mBAAA;AAhHF;AAmHA;EACE,wBAAA;AAjHF;AAsHE;EACE,4BAAA;AApHJ;AAuHQ;EACE,kBAAA;AArHV;AAwHQ;EACE,aAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yCAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;AAtHV;AAyHQ;EACE,cAAA;AAvHV;AA0HQ;EACE,gBAAA;EACA,kBAAA;EACA,0BAAA;EACA,gCAAA;EACA,WAAA;AAxHV;AA2HQ;EACE,gBAAA;EACA,SAAA;EACA,cAAA;AAzHV;AA4HQ;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;AA1HV;AA6HQ;EACE,mBAAA;AA3HV;AA6HE;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AA3HJ;AA6HI;EACE,gBAAA;AA3HN;AA+HE;EACE,UAAA;EACA,QAAA;EACA,SAAA;AA7HJ;AAgIE;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EAEA,gBAAA;AA9HJ;AAiIE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EAEA,gBAAA;AA/HJ;AAkIE;EACE,qCAAA;AAhIJ;AAmIE;EACE,2BAAA;AAjIJ;AAoIE;EAGE,2BAAA;AAlIJ;AAsIE;EACE,mBAAA;AApIJ;AAuIE;EACE,kBAAA;AArIJ;;AA0IA;EACE,wBAAA;AAvIF;;AA0IA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,qCAAA;EACA,+CAAA;EACA,qBAAA;EACA,yBAAA;EACA,8CAAA;AAvIF;;AA0IA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,2CAAA;EACA,YAAA;AAvIF;AA2IE;EACE,kCAAA;EAAA,6BAAA;AAzIJ;AA4IE;EACE,YAAA;AA1IJ;AA6IE;EACE,WAAA;EACA,aAAA;EACA,gBAAA;AA3IJ;AA6II;EACE,yBAAA;EACA,2BAAA;EACA,sBAAA;AA3IN;AA8II;EACE,oCAAA;EACA,4BAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAl/BU;EAm/BV,kBAAA;EACA,YAAA;EACA,eAAA;EACA,oCAAA;AA5IN;;AAmJA;EACE,cAAA;AAhJF;;AA2JA;EACE,cAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;AAxJF;;AA2JA;EACE,cAAA;AAxJF;;AA2JA;EACE,cAAA;EACA,mBAAA;AAxJF;;AA4JA;EACE,UAAA;EACA,gBAAA;EACA,+BAAA;EACA,aAAA;AAzJF;;AA4JA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;AAzJF;AA2JE;EACE,eAAA;EACA,iBAAA;AAzJJ;;AA6JA;EACE,gBAAA;EAEA,YAAA;EACA,mBAAA;EACA,yBAAA;EAEA,cAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;AA5JF;AA8JE;EACE,sCAAA;AA5JJ;;AAgKA;EACE;IACE,aAAA;IACA,mCAAA;EA7JF;EAgKA;IACE,aAAA;EA9JF;AACF;AAiKA;EACE,aAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AA/JF;;AAkKA;EACE,aAAA;AA/JF;;AAkKA;EACE;IACE,aAAA;EA/JF;EAkKA;IACE,WAAA;EAhKF;EAyKE;IACE,wBAAA;EAvKJ;EA8KE;IACE,iBAAA;EA5KJ;EA8KI;IACE,kBAAA;EA5KN;EAiLI;IACE,6BAAA;EA/KN;EAmLM;IACE,eAAA;IACA,eAAA;EAjLR;EAmLQ;IACE,6BAAA;EAjLV;EAyLE;IACE,QAAA;EAvLJ;EAyLI;IACE,4BAAA;EAvLN;EA6LE;IACE,sBAAA;IACA,2BAAA;EA3LJ;AACF;AA+LA;EACE;IACE,sBAAA;IACA,gBAAA;EA7LF;EAgMA;IACE,mBAAA;EA9LF;EAiMA;IACE,iBAAA;IACA,kBAAA;IACA,WAAA;IACA,SAAA;IACA,gBAAA;IACA,gBAAA;IACA,uBAAA;IACA,mBAAA;IACA,YAAA;IACA,gBAAA;EA/LF;EAkMA;IACE,YAAA;EAhMF;EAmMA;IACE,cAAA;EAjMF;EAoMA;IACE,aAAA;EAlMF;EAuME;IACE,wBAAA;EArMJ;EAwME;IACE,WAAA;EAtMJ;EA2ME;IACE,wBAAA;EAzMJ;EA6MA;IACE,sBAAA;IACA,cAAA;EA3MF;EA8MA;IACE,sBAAA;IACA,uBAAA;IACA,cAAA;EA5MF;EA+MA;IACE,cAAA;IACA,WAAA;IACA,eAAA;IACA,eAAA;EA7MF;EAgNA;IACE,WAAA;IACA,cAAA;EA9MF;EAkNE;IACE,2BAAA;EAhNJ;EAoNA;IACE,wBAAA;EAlNF;EAsNA;IACE,sBAAA;IACA,SAAA;IACA,aAAA;EApNF;EAsNE;IACE,WAAA;EApNJ;EAsNI;IACE,iBAAA;IACA,cAAA;EApNN;EAwNE;IACE,sBAAA;IACA,sBAAA;IACA,uBAAA;IACA,SAAA;EAtNJ;EA2NA;IACE,eAAA;IACA,gBAAA;IACA,aAAA;EAzNF;EA6NA;IACE,WAAA;IACA,cAAA;EA3NF;EA6NE;IACE,WAAA;EA3NJ;EAgOA;IACE,sBAAA;IACA,cAAA;IACA,iBAAA;IACA,kBAAA;EA9NF;EAmOE;IACE,sBAAA;IACA,sBAAA;IACA,kCAAA;IACA,SAAA;IACA,gBAAA;EAjOJ;EAmOI;IACE,sBAAA;IACA,sBAAA;IACA,kCAAA;EAjON;EAoOI;IACE,sBAAA;IACA,oBAAA;IACA,aAAA;IACA,sBAAA;IACA,SAAA;EAlON;EAoOM;IACE,oBAAA;IACA,sBAAA;IACA,SAAA;EAlOR;EAqOM;IACE,WAAA;IACA,gBAAA;IACA,uBAAA;IACA,mBAAA;IACA,kBAAA;EAnOR;EAsOM;IACE,8BAAA;IACA,sBAAA;IACA,eAAA;EApOR;EAwOI;IACE,sBAAA;IACA,eAAA;IACA,SAAA;IACA,2BAAA;EAtON;EAwOM;IACE,sBAAA;IACA,sBAAA;EAtOR;EAyOM;IACE,eAAA;IACA,OAAA;IACA,gBAAA;EAvOR;EAyOQ;IACE,kBAAA;IACA,mBAAA;EAvOV;EA8OI;IACE,mBAAA;IACA,eAAA;EA5ON;EA8OM;IACE,sBAAA;IACA,2BAAA;IACA,iBAAA;EA5OR;EA8OQ;IACE,aAAA;EA5OV;EAoPA;IACE,gBAAA;EAlPF;EAqPA;IACE,0BAAA;IACA,WAAA;IACA,cAAA;EAnPF;EAuPA;IACE,mBAAA;IACA,YAAA;EArPF;EAuPE;IACE,WAAA;EArPJ;EAyPA;IACE,gBAAA;IACA,eAAA;IACA,SAAA;IACA,uBAAA;EAvPF;EAyPE;IACE,SAAA;IACA,QAAA;IACA,eAAA;IACA,uBAAA;EAvPJ;EAyPI;IACE,0BAAA;EAvPN;EA0PI;IACE,WAAA;IACA,SAAA;EAxPN;EA0PM;IACE,sBAAA;IACA,0BAAA;EAxPR;EA+PA;IAEE,YAAA;EA9PF;EAgQE;IACE,QAAA;EA9PJ;EAiQE;IACE,eAAA;IACA,uBAAA;IACA,iBAAA;EA/PJ;EAiQI;IACE,sBAAA;IACA,aAAA;EA/PN;EAqQM;IACE,qBAAA;EAnQR;EA2QE;IACE,eAAA;EAzQJ;EA4QE;IACE,sBAAA;EA1QJ;EA4QI;;IAEE,sBAAA;IACA,0BAAA;IACA,eAAA;EA1QN;EA6QI;IACE,QAAA;EA3QN;EA8QI;IACE,QAAA;EA5QN;EAgRE;IACE,uBAAA;IACA,+BAAA;EA9QJ;EAiRE;IACE,sCAAA;IACA,iBAAA;EA/QJ;EAkRE;IACE,sCAAA;IACA,iBAAA;EAhRJ;EAsRE;IACE,iBAAA;IACA,gBAAA;IACA,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,aAAA;EApRJ;EAsRI;IACE,eAAA;IACA,gBAAA;IACA,aAAA;IACA,sBAAA;IACA,gBAAA;EApRN;EAuRI;IACE,cAAA;EArRN;EAwRI;IACE,8BAAA;IACA,aAAA;IACA,gBAAA;IACA,kBAAA;IACA,OAAA;IACA,aAAA;EAtRN;EAyRI;IACE,cAAA;EAvRN;EA4RI;;;IAGE,sBAAA;IACA,0BAAA;IACA,iBAAA;EA1RN;AACF;AA6RI;EACE;IACE,YAAA;IACA,4BAAA;IACA,gBAAA;EA3RN;EA6RM;IACE,gBAAA;EA3RR;EA8RM;IACE,8BAAA;EA5RR;AACF;AA/GA;EAiZE;IACE,4BAAA;IACA,uBAAA;EA/RF;EAiSE;IACE,4BAAA;EA/RJ;EAiSI;IACE,6BAAA;EA/RN;EAqSA;IACE,0CAAA;IACA,0CAAA;IACA,cAAA;IACA,gBAAA;IACA,iCAAA;EAnSF;EAuSA;IACE,2BAAA;IACA,4BAAA;IACA,wBAAA;IACA,4BAAA;IACA,qBAAA;IACA,yBAAA;EArSF;EAuSE;IACE,sBAAA;IACA,6BAAA;EArSJ;EAySA;IACE,2BAAA;IACA,4BAAA;IACA,wBAAA;IACA,4BAAA;IACA,qBAAA;IACA,yBAAA;EAvSF;EAySE;IACE,sBAAA;IACA,6BAAA;EAvSJ;EA4SA;IACE,UAAA;EA1SF;EA8SA;IACE,sBAAA;IACA,eAAA;EA5SF;EA8SE;IACE,iBAAA;EA5SJ;EA+SE;IACE,oBAAA;IACA,qBAAA;EA7SJ;EAmTE;IACE,eAAA;EAjTJ;EAoTE;IACE,SAAA;EAlTJ;EAqTE;IACE,eAAA;EAnTJ;EAyTE;IACE,YAAA;IACA,4BAAA;EAvTJ;EA0TE;IACE,kBAAA;IACA,+BAAA;IACA,gBAAA;EAxTJ;EA6TA;IACE,YAAA;IACA,eAAA;EA3TF;EA6TE;IACE,SAAA;IACA,eAAA;IACA,uBAAA;EA3TJ;EA6TI;IACE,eAAA;IACA,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;EA3TN;AACF;AAiUA;EAGM;IACE,sBAAA;IACA,WAAA;IACA,QAAA;EAjUN;EAmUM;IACE,WAAA;IACA,eAAA;IACA,iBAAA;EAjUR;EAmUQ;IACE,iBAAA;IACA,YAAA;EAjUV;EAwUI;IACE,WAAA;IACA,6BAAA;IACA,QAAA;EAtUN;EAwUM;IACE,OAAA;IACA,eAAA;IACA,eAAA;IACA,gBAAA;EAtUR;EA2UE;IACE,kBAAA;EAzUJ;EA2UI;IACE,iBAAA;EAzUN;EA8UA;IACE,YAAA;EA5UF;EA8UE;IACE,mBAAA;IACA,mBAAA;IACA,QAAA;IACA,eAAA;IACA,uBAAA;EA5UJ;EA8UI;IACE,WAAA;IACA,SAAA;IACA,kBAAA;EA5UN;EA8UM;IACE,sBAAA;EA5UR;EAgVI;IACE,eAAA;IACA,gBAAA;IACA,cAAA;IACA,uBAAA;IACA,YAAA;EA9UN;EAmVA;IACE,eAAA;EAjVF;EAmVE;IACE,sCAAA;IACA,iBAAA;IACA,aAAA;IACA,kBAAA;EAjVJ;EAoVE;IACE,sCAAA;IACA,iBAAA;EAlVJ;EAqVE;IACE,wBAAA;IACA,iBAAA;EAnVJ;EAsVE;IACE,wBAAA;EApVJ;EAyVE;IACE,WAAA;IACA,4BAAA;EAvVJ;EA0VE;IACE,iBAAA;IACA,kBAAA;EAxVJ;EA2VE;IACE,aAAA;IACA,sBAAA;IACA,QAAA;EAzVJ;EA2VI;IACE,WAAA;IACA,SAAA;EAzVN;EA8VA;;IAEE,2BAAA;IACA,4BAAA;IACA,uBAAA;IACA,6BAAA;IACA,gBAAA;EA5VF;EAgWA;IACE,0CAAA;IACA,0CAAA;EA9VF;EAkWA;IACE,qBAAA;IACA,YAAA;EAhWF;EAkWE;IACE,YAAA;EAhWJ;EAqWA;IACE,6BAAA;IACA,uBAAA;IACA,gBAAA;EAnWF;EAwWE;IACE,YAAA;EAtWJ;EAwWI;IACE,gBAAA;IACA,iBAAA;EAtWN;EA4WA;;;;IAIE,iBAAA;IACA,kBAAA;EA1WF;EA8WA;IACE,sBAAA;IACA,eAAA;IACA,QAAA;IACA,OAAA;IACA,aAAA;EA5WF;EA8WE;IACE,sBAAA;EA5WJ;AACF;AAiXA;EACE;IACE,0BAAA;IACA,eAAA;IACA,eAAA;EA/WF;EAkXA;IACE,eAAA;IACA,eAAA;IACA,0CAAA;IACA,0CAAA;EAhXF;EAoXE;IACE,sBAAA;IACA,mBAAA;IACA,mBAAA;IACA,eAAA;IACA,SAAA;EAlXJ;EAoXI;IACE,sBAAA;EAlXN;EAqXI;IACE,sBAAA;IACA,eAAA;EAnXN;EAyXE;IACE,mBAAA;EAvXJ;EAyXI;IACE,qBAAA;EAvXN;EA0XI;IACE,qBAAA;EAxXN;EA8XA;IACE,WAAA;IACA,aAAA;EA5XF;EAgYA;IACE,aAAA;EA9XF;EAgYE;IACE,SAAA;EA9XJ;EAmYA;;IAEE,iBAAA;IACA,aAAA;IACA,kBAAA;EAjYF;AACF;AAsYA;EACE,WAAA;AApYF;AAsYE;EACE,2CAAA;EAEA,YAAA;EAEA,eAAA;AAtYJ;AAuYK;EACC,qBAAA;EAEA,kBAAA;EAGA,2CAAA;AAxYN;AA0YO;EACI,4BAAA;AAxYX;AA0YO;EACC,kBAAA;AAxYR;AA4YI;EACE,aAAA;EACA,uBAAA;AA1YN;AA4YM;EACE,sBAAA;EACA,YAAA;AA1YR;AA4YQ;EACE,4BAAA;AA1YV;;AAiZA;EACE,WAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;AA9YF;AAgZE;EANF;IAOI,eAAA;IACA,eAAA;EA7YF;AACF;;AAgZA;EACE,oBAAA;EACA,WAAA;EACA,eAAA;AA7YF;AA+YE;EACE,UAAA;EACA,kBAAA;AA7YJ;AAgZE;EACE,UAAA;AA9YJ;AAiZE;EACE,kBAAA;EACA,iBAAA;AA/YJ;;AAoZA;EACE,YAAA;EACA,gBAAA;EACA,iBAAA;AAjZF;;AAoZA;EACE;IACE,SAAA;IACA,QAAA;EAjZF;AACF;AAoZA;EACE;IACE,+BAAA;EAlZF;AACF;AAuZA;EACE,aAAA;AArZF;;AAwZA;;;;;;;EAOE,sBAAA;AArZF;;AAwZA;;;;;;;;;;;;;;EAcE,gBAAA;AArZF;;AAwZA;EACE,UAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EAGA,iBAAA;AArZF;;AAwZA;;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;AArZF;;AAwZA;EACE,OAAA;AArZF;;AAwZA;EACE,aAAA;AArZF;;AAwZA;EACE,SAAA;AArZF;;AAwZA;EACE,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;AArZF;;AAwZA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;AArZF;;AAwZA;EACE,0CAAA;AArZF;;AA0ZE;EACE,6BAAA;AAvZJ;AA0ZE;EACE,8BAAA;AAxZJ;AA2ZE;EACE,+BAAA;EACA,gBAAA;EACA,qBAAA;AAzZJ;AA4ZE;EACE,4BAAA;EACA,sBAAA;AA1ZJ;AA6ZE;EACE,0CAAA;EACA,sBAAA;AA3ZJ;AA8ZE;EACE,sBAAA;EACA,WAAA;AA5ZJ;AA+ZE;EACE,iCAAA;AA7ZJ;;AAiaA;EACE,8BAAA;AA9ZF;;AAiaA;EACE,cAAA;AA9ZF;;AAiaA;EACE,+BAAA;EACA,WAAA;AA9ZF;;AAiaA;EACE,eAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,4BAAA;AA9ZF;AAgaE;EACE,4BAAA;AA9ZJ;;AAkaA;EACE,eAAA;EACA,YAAA;EACA,WAAA;AA/ZF;AAiaE;EACE,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AA/ZJ;AAiaI;EACE,2BAAA;EACA,cAAA;EACA,iBAAA;AA/ZN;AAkaI;EACE,4BAAA;AAhaN;AAmaI;EACE,0BAAA;AAjaN;AAmaM;EACE,wCAAA;AAjaR;;AAwaE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;AAraJ;AAwaE;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EAEA,uBAAA;EACA,0BAAA;EACA;;;;OAAA;AAnaJ;AAwaI;EACE,kBAAA;EACA,aAAA;AAtaN;AAwaM;EACE,gDAAA;AAtaR;AAwaQ;EACE,oDAAA;AAtaV;AA2aI;EACE,aAAA;EACA,mBAAA;EACA,uCAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;AAzaN;AA2aM;EACE,aAAA;EACA,cAAA;EACA,WAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,mDAAA;AAzaR;;AA+aA;EACE,qBAAA;AA5aF;;AA+aA;EACE,eAAA;EACA,MAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,0CAAA;EACA,2BAAA;EACA,aAAA;AA5aF;AA+aE;EAZF;IAaI,WAAA;IACA,eAAA;IACA,YAAA;EA5aF;AACF;;AA+aA;EACE,QAAA;AA5aF;AA8aE;EAHF;IAII,QAAA;EA3aF;AACF;;AA8aA;EACE,eAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AA3aF;AA6aE;EACE,cAAA;AA3aJ;;AA+aA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AA5aF;AA8aE;EAGE,cAAA;AA9aJ;AAkbE;EAxBF;IAyBI,eAAA;IACA,WAAA;IACA,aAAA;EA/aF;AACF;;AAkbA;EACE,gBAAA;EACA,aAAA;EAEA,UAAA;AAhbF;;AAobA;EACE,kBAAA;EACA,eAAA;EACA,6BAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AAjbF;AAobE;EACE,mDAAA;EACA,sBAAA;AAlbJ;AAobI;EACE,sCAAA;AAlbN;;AAubA;EACE,yBAAA;EACA,gCAAA;EACA,yBAAA;EACA,WAAA;AApbF;AAsbE;EACE,sBAAA;AApbJ;;AAwbA;EACE,eAAA;AArbF;AAubE;EACE,WAAA;AArbJ;AA2bQ;EACE,kDAAA;EACA,cAAA;AAzbV;AA4bQ;EACE,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AA1bV;AA4bU;EACE,iBAAA;EACA,kBAAA;AA1bZ;;AAmcA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,6BAAA;AAhcF;;AAmcA;EACE,yBAAA;AAhcF;;AAmcA;EACE,eAAA;EACA,OAAA;AAhcF;;AAmcA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;AAhcF;;AA+dA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,gCAAA;AA5dF;;AA+dA;EACE,yBAAA;AA5dF;;AA+dA;EACE,eAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AA5dF;;AA+dA;EAKE,eAAA;EACA,kBAAA;EACA,eAAA;AAheF;AA0dE;EACC,yBAAA;AAxdH;;AAkeA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,6BAAA;AA/dF;;AAkeA;EACE,yBAAA;AA/dF;;AAkeA;EACE,OAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AA/dF;;AAkeA;EACE,eAAA;EACA,WAAA;AA/dF;;AAkeA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;AA/dF;;AAkeA;EACE,cAAA;EACA,eAAA;EACA,eAAA;AA/dF;;AAkeA;EACE,cAAA;AA/dF;;AAmeA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,aAAA;EACA,6BAAA;EACA,kBAAA;AAheF;;AAmeA;EACE,yBAAA;AAheF;;AAmeA;EACE,OAAA;EACA,eAAA;AAheF;;AAmeA;EACE,gBAAA;EACA,WAAA;AAheF;;AAmeA;EACE,eAAA;EACA,WAAA;AAheF;;AAmeA;EACE,iBAAA;EACA,kBAAA;AAheF;;AAmeA;EACE,eAAA;EACA,cAAA;EACA,eAAA;AAheF;;AAmeA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;AAheF;;AAmeA;EACE,aAAA;AAheF;;AAmeA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AAheF;;AAmeA;EACE,iBAAA;AAheF;;AAmeA;EACE,eAAA;EACA,cAAA;EACA,eAAA;AAheF;;AAmeA;EACE,cAAA;AAheF;;AAmeA;EACE,2BAAA;EACA,0BAAA;AAheF;AAieE;EACE,0BAAA;AA/dJ;AAieE;EACI,8BAAA;AA/dN;AAgeI;EACA,2CAAA;AA9dJ;AAieG;EACC,2BAAA;AA/dJ;AAgeI;EACE,8BAAA;AA9dN;AA+dM;EACE,sCAAA;AA7dR;AAkeE;EACE,sBAAA;EACA,yBAAA;AAheJ;;AAmeA;EACE,2BAAA;AAheF;;AAkeC;EACC,+BAAA;AA/dF;;AAkeE;EACE,mCAAA;AA/dJ;AAieE;EACE,+BAAA;EACA,WAAA;AA/dJ;AAgeI;EACE,sBAAA;AA9dN;AAkeI;EACE,6BAAA;AAheN;AAmeE;EACE,2BAAA;EACC,gBAAA;EACC,WAAA;EACA,oBAAA;EACA,2CAAA;AAjeN;AAmeE;EACE,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAjeJ;AAqeK;EACC,sBAAA;EACA,yBAAA;EACD,kBAAA;EACA,2BAAA;EACA,+BAAA;AAneL;AAoeM;EACE,UAAA;EACA,sBAAA;AAleR;AAqeQ;EACE,WAAA;AAneV;AAyeG;EACC,2BAAA;AAveJ;AA0eE;EACE,0BAAA;EACA,gBAAA;AAxeJ;AA2eE;EACE,kBAAA;EACA,UAAA;EACA,YAAA;AAzeJ;AA2eE;EACE,8BAAA;AAzeJ;;AA8eC;EACC,cAAA;EACA,4BAAA;EACA,kBAAA;EAEA,+KAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AA5eF;AA8eE;EACE,aAAA;AA5eJ;;AAgfA;EACI,gBAAA;EACA,sBAAA;AA7eJ;AA8eI;EACE,aAAA;AA5eN;;AAifA;EACM,2BAAA;AA9eN;;AAifA;EACE,yBAAA;EACA,YAAA;AA9eF;;AAifA;EACE,gBAAA;EACC,yBAAA;EACA,YAAA;AA9eH;AAgfG;EACC,qCAAA;EACA,WAAA;EACA,YAAA;AA9eJ;;AAofA;EACM,2BAAA;AAjfN;;AAofA;EACE,yBAAA;EACA,YAAA;AAjfF;;AAofA;EACE,gBAAA;EACC,yBAAA;EACA,YAAA;AAjfH;AAmfG;EACC,qCAAA;EACA,WAAA;EACA,YAAA;AAjfJ;;AA2fC;EACE,gCAAA;AAxfH;;AA2fA;EACI,gBAAA;EACA,sBAAA;EACA,yBAAA;EAEA,kBAAA;AAzfJ;AA4fI;EACE,gBAAA;EACA,yBAAA;EAEA,kBAAA;AA3fN;AA6fM;EACE,YAAA;AA3fR;AA4fQ;EACE,0BAAA;AA1fV;AA6fO;EACG,8BAAA;EACA,cAAA;AA3fV;AA8fQ;EACE,2BAAA;AA5fV;;AAmgBA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;AAhgBF;;AAihBA;EACE,aAAA;AA9gBF;;AAkhBE;EACE,WAAA;EACA,sBAAA;AA/gBJ;AAghBI;EACA,gBAAA;AA9gBJ;AAkhBE;EACE,iBAAA;AAhhBJ;AAmhBE;EACE,+BAAA;AAjhBJ;AAkhBI;EACE,iBAAA;EACA,sBAAA;AAhhBN;;AAuhBA;EACE,uBAAA;AAphBF;;AAshBA;EACE,cAAA;AAnhBF;AAohBE;EACE,kBAAA;EACA,UAAA;AAlhBJ;AAohBM;EACE,WAAA;EACA,mBAbC;EAcD,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,0BAAA;AAlhBR;AAuhBQ;EACE,yBA9BD;EA+BC,mCAAA;AArhBV;AA2hBQ;EACE,aAAA;EACA,qBAvCD;AAlfT;AA+hBQ;EACE,mCAAA;EACA,qBAAA;EACA,mBAAA;AA7hBV;AAmiBQ;EACE,eAAA;AAjiBV;;AAwiBA;EACE,eAAA;AAriBF;;AAuiBA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;EACA,aAAA;AApiBF;AAsiBE;EARF;IASI,sBAAA;IACA,YAAA;EAniBF;AACF;;AAwiBE;EACE,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAriBJ;AAuiBI;EACE,mBAAA;EACA,qBAAA;AAriBN;AAwiBI;EACE,kBAAA;EACA,mBAAA;AAtiBN;AAyiBI;EACE,kBAAA;EACA,mBAAA;AAviBN;AA0iBI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,eAAA;AAxiBN;AA2iBI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,oBAAA;AAziBN;AA2iBM;EACE,iBAAA;EACA,cAAA;EACA,sBAAA;AAziBR;AA4iBM;EACE,kBAAA;EACA,WAAA;AA1iBR;AA4iBQ;EACE,cAAA;EACA,sBAAA;AA1iBV;AA8iBM;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;AA5iBR;AAijBE;EACE,gBAAA;AA/iBJ;AAijBI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,qBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,yCAAA;EACA,oBAAA;AA/iBN;AAijBM;EACE,wCAAA;AA/iBR;AAkjBM;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;AAhjBR;AAkjBQ;EACE,eAAA;EACA,cAAA;AAhjBV;AAojBM;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAljBR;AAojBQ;EACE,gBAAA;EACA,WAAA;EACA,SAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AAljBV;AAqjBQ;EACE,WAAA;EACA,mBAAA;EACA,SAAA;AAnjBV;AAujBM;EACE,cAAA;EACA,YAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;AArjBR;AAujBQ;EACE,WAAA;EACA,mBAAA;AArjBV","sourcesContent":["// :host{\n//     width:100%;\n//     display: flex;\n//     flex-direction: column;\n// }\n:host{\n  height:100vh;\n  background: #fff;\n}\n#botWrapper {\n  display: flex;\n  width: 100%;\n  position: relative;\n  justify-content: center;\n  padding: 0px 5px;\n  background:#fff !important;\n}\n\n$primary-color: #133aa5;\n\nbody::ng-deep {\n  overflow-y: hidden !important;\n}\n\n.second-level-menu {\n  background: transparent !important;\n  min-width: auto !important;\n  max-width: 350px !important;\n}\n\nheader {\n  border-left: 0px !important;\n  height: auto !important;\n}\n\n.chat-header {\n  height: auto;\n  justify-content: center;\n  margin-top: 10px;\n  position: relative;\n  display: flex;\n}\n\n.chat-header,\n.chat-content {\n  width: 100%;\n  display: flex;\n  margin: 10px auto;\n\n}\n\n#botinput-wrapper,\n#chat-list-content {\n  ul.dropdown-menu {\n    box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;\n\n    li {\n      display: flex;\n      align-items: center;\n      padding-left: 10px;\n      color: #666;\n      height: 30px;\n      cursor: pointer;\n\n    }\n\n    & li:hover {\n      background: #f1f1f1;\n    }\n  }\n}\n\n#chat-list-content {\n  ul.dropdown-menu {\n\n    li {\n\n      gap: 10px;\n    }\n  }\n}\n\n.chat-content {\n  width: 90%;\n  justify-content: space-evenly;\n}\n\n.wrapper {\n  display: flex;\n  height: 100%;\n  flex-direction: row;\n  justify-content: stretch;\n}\n\n.chat-sidebar {\n  max-width: 320px;\n  height: 100%;\n  background: #fff;\n  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 0px 2.6px;\n}\n\n\n.chatBotstyle {\n  display: flex;\n  flex-direction: row;\n  width: 100% !important;\n  height: 100%;\n}\n\n.hide {\n  display: none;\n}\n\n.fa {\n  cursor: pointer;\n}\n\n.chat-box-wrapper {\n  position: relative;\n  display: flexbox;\n  width: 90%;\n}\n\n.chat-left-content {\n  background: #fff;\n  min-width: 280px;\n  overflow-y: auto;\n  /* box-shadow:2px 0px 0px rgba(0, 0, 0, 0.21); */\n  /* box-shadow:3px 0px #e9e9e9; */\n}\n\n.chat-right-content {\n  /* margin-left:20px; */\n  /* width: clamp(300px,150vw,70vw); */\n  min-width: 70%;\n  width: 100%;\n  overflow-y: auto;\n  display: flex;\n  justify-content: space-evenly;\n}\n\n#title {\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n  justify-content: space-evenly;\n  margin: 10px 0px;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.chat-history-list {\n  height: 100vh;\n  //  background:rgba(0,0,0,.1);\n  width: 100%;\n  margin-left: 0px;\n  position: absolute;\n  z-index: 9;\n  right: 0px;\n  top: 0px;\n\n  .left-box-shadow {\n    box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;\n  }\n\n  .listing-data {\n    height: 90vh;\n    overflow-y: auto;\n    background: #fff;\n    padding-bottom: 1.5em;\n    padding-left: .5rem;\n    // width: 295px;\n  }\n\n  .listing-data.templatesection {\n    height: 100vh;\n  }\n\n  .audio-wrapper {\n    position: absolute;\n    z-index: 999;\n    right: -2rem;\n    background: rgba(0, 0, 0, 0.5);\n    // display: none;\n\n    // audio{\n    //     width:300px !important;\n    // }\n\n  }\n\n  .audio-wrapper.is-active {\n\n    display: block;\n  }\n}\n// select{\n//   color: var(--textsecondarycolor) !important;\n//   font-size:.9rem;\n//   option {\n//   display: flex;\n//   justify-content: flex-start;\n//   gap: 20px;\n//   border: 2px solid #a7a7a7;\n\n//   padding: 10px;\n//   transition: 0.4s;\n//  }\n// }\n\n\n select {\n  appearance: base-select;\n  color: var(--textsecondarycolor) !important;\n  background-color: transparent;\n  width: 180px;\n  height:2rem;\n  font-size: 1rem;\n  box-sizing: border-box;\n  padding: 0.5rem 0.75rem;\n  border: 1px solid #a7a7a7;\n  border-radius: calc(0.5rem - 2px);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  cursor: pointer;\n\n  & > button {\n    display: flex;\n    width: 100%;\n    font-family: inherit;\n    color: currentColor;\n\n    & > svg {\n      margin: 0 0 0 auto;\n      width: 1.2rem;\n      height: 1.2rem;\n    }\n  }\n\n  &:has(option:not([hidden]):checked) {\n     color: var(--textsecondarycolor);\n  }\n\n  &:focus-visible {\n    outline: 2px solid #a1a1aa;\n    outline-offset: -1px;\n  }\n\n  &::picker-icon {\n    display: none;\n  }\n\n  &::picker(select) {\n    appearance: base-select;\n    border: 1px solid #e4e4e7;\n    padding: 0.25rem;\n    margin-top: 0.25rem;\n    border-radius: calc(0.5rem - 2px);\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),\n      0 2px 4px -2px rgba(0, 0, 0, 0.1);\n    cursor: default;\n    transition: opacity 225ms ease-in-out, transform 225ms ease-in-out;\n    transform-origin: top;\n    transform: translateY(0);\n    opacity: 1;\n\n    @starting-style {\n      transform: translateY(-0.25rem) scale(0.95);\n      opacity: 0;\n    }\n  }\n\n  & optgroup label {\n    display: block;\n    padding: 0.375rem 0.5rem;\n  }\n\n  & option {\n    padding: 0.375rem 0.5rem;\n    border-radius: calc(0.5rem - 4px);\n    outline: none;\n\n    &::after {\n      content: \"\";\n      width: 1rem;\n      height: 1.5rem;\n      margin-left: auto;\n      opacity: 0;\n     // background: center / contain no-repeat  url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%2318181b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M20 6 9 17l-5-5'%3E%3C/path%3E%3C/svg%3E\");\n    }\n\n    &::checkmark {\n      display: none;\n    }\n\n    &:checked {\n     // background-color: transparent;\n     background-color: #f4f4f5;\n      &::after {\n        opacity: 1;\n      }\n    }\n\n    &:hover,\n    &:focus-visible {\n      background-color: #f4f4f5;\n      color: var(--textsecondarycolor);\n    }\n  }\n}\n\n.select:not(.is-multiple):not(.is-loading)::after {\n  right: 1.5em;\n  z-index: 4;\n  top:15px;\n  font-size:1rem;\n}\n\n::ng-deep .audio-file-class {\n  width: 100%;\n  min-width: 300px;\n}\n\n.chat-history-list ul {\n  margin: 10px 0px;\n  padding: 0px 10px;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  line-height: 1.2rem;\n\n  & li {\n    display: inline-flex;\n    justify-content: space-evenly;\n    align-items: baseline;\n    border-bottom: 1px solid var(--bodyBgColor) !important;\n    color: #000 !important;\n\n\n    & label:first-child {\n      display: inline-block;\n      // background: var(--menuSelectColor);\n      //color: var(--primaryColor);\n      border-radius: 10px;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      cursor: pointer;\n      font-size: .9rem;\n      min-height: 25px;\n      padding: 10px 10px;\n      margin-bottom: 10px;\n      width: 90%;\n    }\n\n    & label:last-child {\n      margin: 0% 3%;\n      display: inline-block;\n      width: 5%;\n      padding-left: 2%;\n    }\n  }\n}\n\n#chat-list-content {\n  position: relative;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  max-width: 960px;\n  font-size: .9rem !important;\n  max-height: 66vh;\n  min-height:66vh;\n  overflow-y: auto;\n  scrollbar-width: none;\n}\n\n/* #chat-list-content.left-tab-show{\n    width: 65%;\n    #chat-list{\n        width:95%;\n        margin-left:0%;\n    }\n}\n\n#chat-list-content.right-tab-show{\n    width: 65%;\n    #chat-list{\n        width:98%;\n        margin-left:0%;\n    }\n}\n#chat-list-content.left-tab-show.right-tab-show{\n    width:54%;\n    #chat-list{\n        width:65%;\n    }\n} */\n#chat-list {\n  // position: relative;\n  // overflow-y: scroll;\n  width: 100%;\n  display: inline-block;\n\n  // justify-content: center;\n  margin-left: 0rem;\n  // left:5%;\n  //  height:90vh;\n  // height:calc(100vh - 100px);\n  padding-bottom: 5%;\n  // padding-right:5px;\n  -ms-overflow-style: none;\n  /* IE and Edge */\n  scrollbar-width: none;\n  /* Firefox */\n\n}\n\n#chat-list::-webkit-scrollbar {\n  display: none;\n}\n\n.chat-list-row {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  max-width: 960px;\n}\n\n\n\n#chat-message-enter-box {\n\n  background: #fbfbfb;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  align-items: center;\n  border-radius:1rem;\n  //box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;\n // height: 90px;\n  z-index: 1;\n   border:1px solid #dcdcdc;\n\n   @media screen and (max-width: 767px) {\n     border-radius: 1.5rem;\n     padding: 5px;\n   }\n\n  & form {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    width: 100%;\n\n    @media screen and (max-width: 767px) {\n      padding: 5px;\n    }\n  }\n\n  & textarea {\n    width: 100% !important;\n    border: none;\n    padding: 10px;\n    color: #666;\n    font-size: 1em;\n    resize: none;\n    height: 55px;\n\n    @media screen and (max-width: 767px) {\n      padding: 8px;\n      font-size: 0.9rem;\n      height: 50px;\n    }\n\n    @media screen and (max-width: 480px) {\n      padding: 6px;\n      font-size: 0.85rem;\n      height: 45px;\n    }\n  }\n\n  & span {\n    display: inline-block;\n    color: #666;\n    width: 100% !important;\n    padding: 10px;\n    color: #666;\n    font-size: 1em;\n    min-height: 40px;\n\n    @media screen and (max-width: 767px) {\n      padding: 8px;\n      font-size: 0.9rem;\n      min-height: 35px;\n    }\n\n    @media screen and (max-width: 480px) {\n      padding: 6px;\n      font-size: 0.85rem;\n      min-height: 30px;\n    }\n  }\n}\n\n/* .chat-header > span{\n    display: inline-block;\n        color: #666;\n        width: 90% !important;\n        padding: 10px;\n        color: #666;\n        font-size:1em;\n        min-height:100px;\n} */\n\n.fa-cloud,\n.fa-user-circle {\n  color: #9da0a3;\n  margin-top: 5px;\n  font-size: 30px !important;\n}\n\napp-toggle-icon::ng-deep .fa-microphone-slash,\n.fa-microphone-slash {\n  opacity: 0.5 !important;\n}\n\ntextarea::placeholder {\n  color: rgb(182, 182, 182) !important;\n}\n\n.question {\n  background: #848a92;\n  /* background: #9da0a3;   */\n  /* background: #01488f; */\n  min-height: 50px;\n  border-radius: 5px;\n  padding: 10px;\n  color: #fff;\n  margin-bottom: 10px;\n  width: 100%;\n  margin-left: 20px;\n  position: relative;\n  /* box-shadow: 2px 2px 3px #000; */\n  /* box-shadow: rgba(25, 118, 210, 0.35) 0px 5px 15px; */\n  /* box-shadow: rgba(109, 129, 153, 0.35) 0px 5px 15px; */\n}\n\n.question::before {\n  content: \" \";\n  position: absolute;\n  width: 0;\n  height: 0;\n  left: -20px;\n  right: auto;\n  top: 0px;\n  bottom: auto;\n  border: 21px solid;\n  border-color: #848a92 transparent transparent transparent;\n  /* border-color: #9da0a3 transparent transparent transparent;  */\n  /* border-color:#01488f transparent transparent transparent; */\n\n}\n\n.question.align-right {\n  /* background: #f2fcff; */\n  background: #9da0a3;\n  min-height: 50px;\n  border-radius: 5px;\n  padding: 10px;\n  color: #fff;\n  margin-bottom: 10px;\n  width: 100%;\n  margin-left: 50%;\n  margin-right: 15px;\n  position: relative;\n}\n\n.question.align-right::before {\n  content: \" \";\n  position: absolute;\n  width: 0;\n  height: 0;\n  left: auto;\n  right: -20px;\n  top: 0px;\n  bottom: auto;\n  border: 21px solid;\n  border-color: #848a92 transparent transparent transparent;\n\n}\n\nvideo {\n  margin: 10px 0px;\n}\n\n.answer {\n  background: #fff;\n  min-height: 50px;\n  border-radius: 5px;\n  padding: 10px;\n  color: #666;\n  margin-bottom: 30px;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin-left: 19px;\n\n  /* box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px; */\n  .answer-header {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n    padding-right: 10px;\n    gap: 15px;\n  }\n\n  .audio {\n    cursor: pointer;\n  }\n\n  .menu-list {\n    position: relative;\n\n    & ul {\n      position: absolute;\n      /* background: #f5fdff; */\n      /* padding: 10px; */\n      /* z-index: 9999; */\n      top: -10px;\n      right: 0px;\n      width: max-content;\n\n      /* box-shadow: 3px 3px #008cb3;\n            border-radius:5px;\n            border: 1px solid #95bdc7; */\n      & li {\n        margin: 10px 10px !important;\n        display: inline-block;\n        cursor: pointer;\n        /* .fa{\n                 color: #008cb3;\n                } */\n      }\n\n      & li:hover {\n        .fa {\n          color: #008cb3;\n        }\n      }\n    }\n\n    & ul.active {\n      display: block;\n    }\n\n    & label {\n      width: 20px;\n      display: flex;\n      justify-content: center;\n      cursor: pointer;\n    }\n\n\n  }\n}\n\n.answer-content::before {\n  content: \" \";\n  position: absolute;\n  width: 0;\n  height: 0;\n  left: -32px;\n  right: auto;\n  top: -35px;\n  bottom: auto;\n  border: 21px solid;\n  border-color: #fff transparent transparent transparent;\n}\n\n.answer-content {\n  position: relative;\n  margin-top: 25px;\n\n  & ol {\n    padding: 30px;\n  }\n}\n\n.chat-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 100%;\n  background: #d2daf3;\n\n  img {\n    border-radius: 100%;\n  }\n}\n\n.username {\n  width: 36px;\n  height: 36px;\n  border-radius: 100%;\n  background: #d2daf3;\n  color: $primary-color;\n  vertical-align: middle;\n  text-align: center;\n  font-size: 22px;\n  margin-right: 5px;\n  display: inline-block;\n  text-transform: uppercase;\n\n}\n\n#chatForm {\n  width:98%;\n  height: inherit;\n\n}\n\n#chatForm>span {\n  width: 90%;\n  height: inherit;\n  margin-left: 10px;\n\n}\n\n#expand-collapse {\n  position: relative;\n  margin-top: 25px;\n  height: 15px;\n\n  i {\n    background: #fff;\n    padding: 7px;\n  }\n\n  .fa {\n    font-size: 1.5em !important;\n    transform: rotate(180deg) translateX(0px);\n    transform-origin: 50% 20%;\n  }\n\n}\n\n#expand-collapse-right {\n  position: relative;\n\n  height: 15px;\n\n  i {\n    background: #fff;\n    padding: 7px;\n  }\n\n  .fa {\n    font-size: 1.5em !important;\n    transform: rotate(0deg) translateX(0px);\n    transform-origin: 50% 20%;\n  }\n\n}\n\n::-webkit-scrollbar {\n  width: 3px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: #fff;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #fff;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #fff;\n}\n\n#chat-content-wrapper {\n  // display: flex;\n  // justify-content:space-between;\n  // width:100%;\n\n  header {\n    background: transparent !important;\n    padding: 5px !important;\n  }\n}\n\n\n#voice-message {\n  width: 80% !important;\n  position: relative;\n // background: #fff;\n  margin-top: -40px;\n  margin-left: 10px;\n  padding-right: 10px;\n  height: 40px;\n\n  span {\n    display: inline-block;\n    color: #4d4d4d;\n  }\n}\n\n#chat-tools-wrapper{\n  display: flex;\n  width:100%;\n  justify-content: end;\n // background:#f8f8f8;\n  padding:10px;\n // border-top: 1px solid #e5e5e5;\n  border-bottom-right-radius:2rem;\n border-bottom-left-radius:2rem;\n\n @media screen and (max-width: 767px) {\n   justify-content: center;\n   padding: 8px;\n   border-bottom-right-radius: 1.5rem;\n   border-bottom-left-radius: 1.5rem;\n }\n}\n#chat-tools {\n  display: flex;\n  list-style-type: none;\n  width: auto;\n  flex-direction: row;\n  gap: 20px;\n  padding: 0px;\n  margin: 0px;\n  position: relative;\n  right: 10px;\n//  top: 30px;\n\nli{\n  display: flex;\n  align-items: center;\n}\n\n.pi-send{\n  transform: rotate(45deg);\n}\n  // .fa-paper-plane {\n  //   font-size: 17px !important;\n  // }\n  .pi,.fa{\n    font-size:1.2rem !important;\n  }\n\n        li.selected-docs-menu {\n          position: relative;\n        }\n\n        li.selected-docs-menu .hover-menu {\n          display: none;\n          position: absolute;\n          right: 0;\n          top: 28px;\n          min-width: 220px;\n          max-width: 420px;\n          max-height: 260px;\n          overflow-y: auto;\n          background: #fff;\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n          border: 1px solid #e5e5e5;\n          border-radius: 6px;\n          padding: 8px 0;\n          z-index: 1000;\n        }\n\n        li.selected-docs-menu:hover .hover-menu {\n          display: block;\n        }\n\n        li.selected-docs-menu .hover-menu .menu-header {\n          font-weight: 600;\n          font-size: .85rem;\n          padding: 6px 12px 8px 12px;\n          border-bottom: 1px solid #f0f0f0;\n          color: #333;\n        }\n\n        li.selected-docs-menu .hover-menu .menu-list {\n          list-style: none;\n          margin: 0;\n          padding: 6px 0;\n        }\n\n        li.selected-docs-menu .hover-menu .menu-list li {\n          font-size: .85rem;\n          color: #444;\n          padding: 6px 12px;\n          white-space: nowrap;\n          text-overflow: ellipsis;\n          overflow: hidden;\n          max-width: 380px;\n        }\n\n        li.selected-docs-menu .hover-menu .menu-list li:hover {\n          background: #f7f7f7;\n        }\n  .switch {\n    position: relative;\n    display: inline-block;\n    width: 35px;\n    height: 20px;\n\n    span {\n      min-height: 20px;\n    }\n  }\n\n  .switch input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n  }\n\n  .slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #ccc;\n    -webkit-transition: .4s;\n    transition: .4s;\n  }\n\n  .slider:before {\n    position: absolute;\n    content: \"\";\n    height: 15px;\n    width: 15px;\n    left: 4px;\n    bottom: 3px;\n    background-color: white;\n    -webkit-transition: .4s;\n    transition: .4s;\n  }\n\n  input:checked+.slider {\n    background-color: var(--primaryColor);\n  }\n\n  input:focus+.slider {\n    box-shadow: 0 0 1px #2196F3;\n  }\n\n  input:checked+.slider:before {\n    -webkit-transform: translateX(13px);\n    -ms-transform: translateX(13px);\n    transform: translateX(13px);\n  }\n\n  /* Rounded sliders */\n  .slider.round {\n    border-radius: 34px;\n  }\n\n  .slider.round:before {\n    border-radius: 50%;\n  }\n\n}\n\n[hidden] {\n  display: none !important;\n}\n\n.comment-area-box::after {\n  content: \"\";\n  position: absolute;\n  width: 0;\n  height: 0;\n  top: 1px;\n  left: 99%;\n  box-sizing: border-box;\n  border: 10px solid rgba(0, 0, 0, 0.5);\n  border-color: transparent transparent #fff #fff;\n  transform-origin: 0 0;\n  transform: rotate(135deg);\n  box-shadow: -1px 1px 1px 0 rgba(0, 0, 0, 0.35);\n}\n\n.comment-area-box {\n  position: absolute;\n  z-index: 999;\n  top: 40px;\n  right: 0px;\n  display: none;\n  background: #fff;\n  padding: 20px 40px;\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 5px;\n  width: 300px;\n\n\n\n  label {\n    width: fit-content !important;\n  }\n\n  textarea {\n    resize: none;\n  }\n\n  .form-btns {\n    width: 100%;\n    display: flex;\n    margin: 10px 0px;\n\n    .btn:first-child {\n      border: 1px solid #dbdbdb;\n      background: #fff !important;\n      color: #000 !important;\n    }\n\n    .btn {\n      --bs-btn-line-height: 1.2 !important;\n      font-size: .9rem !important;\n      padding: 5px 20px;\n      color: #fff;\n      background: $primary-color;\n      margin-right: 15px;\n      border: none;\n      cursor: pointer;\n      font-family: \"Noto Sans\", sans-serif;\n    }\n  }\n\n\n}\n\n.comment-area-box.is-active {\n  display: block;\n}\n\n// #langselect{\n//     margin-top:5px;\n//     margin-left:10px;\n// }\n\n\n\n\n.dropdown-list {\n  display: block;\n  border-radius: 5px;\n  display: block;\n  height: 30px;\n  padding: 5px;\n  border: 1px solid gray;\n}\n\n.dropdown-list.show {\n  display: block;\n}\n\n.toggle-button {\n  display: block;\n  margin-bottom: 10px;\n}\n\n\n#right-side-panel {\n  width: 20%;\n  background: #fff;\n  box-shadow: 0px 0px 4px #b2b2b2;\n  padding: 10px;\n}\n\n#designlist {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  padding: 10px;\n\n  label {\n    font-size: 14px;\n    font-weight: bold;\n  }\n}\n\n#designlist li {\n  list-style: none;\n\n  margin: 10px;\n  white-space: nowrap;\n  border: 1px solid #dcd8d8;\n\n  color: #222222;\n  cursor: pointer;\n  width: 100%;\n  height: 100px;\n  overflow: hidden;\n\n  &.active {\n    border: 2px dashed var(--primaryColor);\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .toggle-button {\n    display: none;\n    /* Hide button for larger screens */\n  }\n\n  .mobile-close-btn {\n    display: none;\n  }\n}\n\n.dropdown-trigger {\n  display: flex;\n  position: relative;\n  right: 0px;\n  justify-content: end;\n  align-items: end;\n  text-align: end;\n  width: 32px;\n}\n\n.select-container {\n  padding: 10px;\n}\n\n@media screen and (max-width:640px) {\n  #chat-content-wrapper.hide {\n    display: none;\n  }\n\n  .chat-history-list {\n    width: auto;\n\n  }\n\n  //  .chat-history-list::ng-deep .tabs-container.vertical{\n  //     width:85% !important;\n  // }\n\n  .tabs-container.vertical {\n    .tab-content.active {\n      width: calc(100% - 20px);\n    }\n  }\n\n\n  // Extra small devices\n  app-page-header {\n    .page-title {\n      font-size: 0.9rem;\n\n      .icon {\n        font-size: 0.85rem;\n      }\n    }\n\n    .pull-right {\n      > span:first-child {\n        font-size: 0.75rem !important;\n      }\n\n      .radio-group {\n        .radio {\n          min-width: 80px;\n          margin: 0.15rem;\n\n          label {\n            font-size: 0.75rem !important;\n          }\n        }\n      }\n    }\n  }\n\n  #chat-tools-wrapper {\n    #chat-tools {\n      gap: 8px;\n\n      li {\n        font-size: 0.9rem !important;\n      }\n    }\n  }\n\n  .right-sidebar {\n    .tab-list li {\n      width: 45px !important;\n      padding: 8px 5px !important;\n    }\n  }\n}\n\n@media screen and (min-width: 320px) and (max-width: 767px) {\n  audio {\n    width: 100% !important;\n    max-width: 300px;\n  }\n\n  #expand-collapse {\n    visibility: visible;\n  }\n\n  .select-container {\n    padding: 0px 20px;\n    position: absolute;\n    right: 20px;\n    top: 70px;\n    background: #fff;\n    /* width: 28%; */\n    justify-content: center;\n    align-items: center;\n    height: 21vh;\n    min-width: 148px;\n  }\n\n  .dropdown-list {\n    margin: 10px;\n  }\n\n  .mobile-close-btn {\n    display: block;\n  }\n\n  .hidemobileView {\n    display: none;\n  }\n\n\n  #botWrapper.rightpanel-active {\n    #chat-content-wrapper {\n      display: none !important;\n    }\n\n    #right-side-panel {\n      width: 100%;\n    }\n  }\n\n  #botWrapper.leftpanel-active {\n    #chat-content-wrapper {\n      display: none !important;\n    }\n  }\n\n  #botinput-wrapper {\n    width: 100% !important;\n    padding: 0 5px;\n  }\n\n  .chat-header {\n    width: 100% !important;\n    justify-content: center;\n    padding: 0 5px;\n  }\n\n  #chat-list-content {\n    padding: 1% 0%;\n    width: 100%;\n    margin-left: 0%;\n    max-width: 100%;\n  }\n\n  #chat-list {\n    width: 100%;\n    padding: 0 5px;\n  }\n\n  #chat-content-wrapper {\n    header {\n      padding: 0px 5px !important;\n    }\n  }\n\n  #designlist li {\n    height: 150px !important;\n  }\n\n  // Mobile header improvements\n  .mobileBased-header-section {\n    flex-direction: column;\n    gap: 10px;\n    padding: 10px;\n\n    .page-title {\n      width: 100%;\n\n      .icon {\n        font-size: 0.9rem;\n        padding: 5px 0;\n      }\n    }\n\n    .pull-right {\n      width: 100% !important;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 10px;\n    }\n  }\n\n  // Better touch targets\n  .tab-list li {\n    min-width: 44px;\n    min-height: 44px;\n    padding: 10px;\n  }\n\n  // Chat input improvements\n  #chat-message-enter-box {\n    width: 100%;\n    margin: 0 auto;\n\n    #chatForm {\n      width: 100%;\n    }\n  }\n\n  // Voice message area\n  #voice-message {\n    width: 100% !important;\n    margin-left: 0;\n    padding: 5px 10px;\n    font-size: 0.85rem;\n  }\n\n  // Mobile responsive header\n  app-page-header {\n    .pull-right {\n      width: 100% !important;\n      flex-direction: column;\n      align-items: flex-start !important;\n      gap: 10px;\n      margin-top: 10px;\n\n      &.mobile-header-section {\n        width: 100% !important;\n        flex-direction: column;\n        align-items: flex-start !important;\n      }\n\n      > span {\n        width: 100% !important;\n        margin: 0 !important;\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n\n        &.mobile-doc-title {\n          margin: 0 !important;\n          flex-direction: column;\n          gap: 10px;\n        }\n\n        &:first-child {\n          width: 100%;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n          font-size: 0.85rem;\n        }\n\n        .mobile-title-text {\n          white-space: normal !important;\n          word-break: break-word;\n          max-width: 100%;\n        }\n      }\n\n      .radio-group {\n        width: 100% !important;\n        flex-wrap: wrap;\n        gap: 10px;\n        justify-content: flex-start;\n\n        &.mobile-radio-group {\n          flex-direction: column;\n          width: 100% !important;\n        }\n\n        .radio {\n          margin: 0.25rem;\n          flex: 1;\n          min-width: 100px;\n\n          label {\n            font-size: 0.85rem;\n            white-space: nowrap;\n          }\n        }\n      }\n    }\n\n    .right-menu {\n      .tab-list {\n        gap: 5px !important;\n        flex-wrap: wrap;\n\n        li {\n          width: 35px !important;\n          padding: 8px 5px !important;\n          font-size: 0.9rem;\n\n          &::before {\n            content: none;\n          }\n        }\n      }\n    }\n  }\n\n  // Mobile responsive bot wrapper\n  #botWrapper {\n    padding: 0px 5px;\n  }\n\n  .bot-middle-content {\n    min-width: 100% !important;\n    width: 100%;\n    padding: 0 5px;\n  }\n\n  // Mobile responsive chat input\n  #chat-message-enter-box {\n    border-radius: 1rem;\n    padding: 8px;\n\n    #chatForm {\n      width: 100%;\n    }\n  }\n\n  #chat-tools-wrapper {\n    padding: 8px 5px;\n    flex-wrap: wrap;\n    gap: 10px;\n    justify-content: center;\n\n    #chat-tools {\n      gap: 10px;\n      right: 0;\n      flex-wrap: wrap;\n      justify-content: center;\n\n      li {\n        font-size: 1rem !important;\n      }\n\n      .category-dropdown-wrapper {\n        width: 100%;\n        order: -1;\n\n        ::ng-deep .p-dropdown {\n          width: 100% !important;\n          min-width: 100% !important;\n        }\n      }\n    }\n  }\n\n  // Mobile responsive sidebar\n  .right-sidebar {\n    // width: 100% !important;\n    right: -100%;\n\n    &.open {\n      right: 0;\n    }\n\n    .tab-list {\n      flex-wrap: wrap;\n      justify-content: center;\n      padding: 10px 5px;\n\n      li {\n        width: 50px !important;\n        padding: 10px;\n      }\n    }\n\n    .tab-content {\n      .tab-view {\n        .listing-data {\n          padding-left: 0.25rem;\n        }\n      }\n    }\n  }\n\n  // Mobile responsive popup view\n  .ai-assist-popup {\n    .container {\n      padding: 0.5rem;\n    }\n\n    .row {\n      flex-direction: column;\n\n      .col-8,\n      .col-4 {\n        width: 100% !important;\n        max-width: 100% !important;\n        padding: 0.5rem;\n      }\n\n      .col-8 {\n        order: 2;\n      }\n\n      .col-4 {\n        order: 1;\n      }\n    }\n\n    .card {\n      height: auto !important;\n      max-height: calc(100vh - 100px);\n    }\n\n    .pop-content {\n      height: calc(100vh - 300px) !important;\n      max-height: 400px;\n    }\n\n    .list-wrapper.list-overflow {\n      height: calc(100vh - 200px) !important;\n      max-height: 300px;\n    }\n  }\n\n  // Mobile responsive modal\n  .policy-upload {\n    .modal-dialog {\n      margin: 10px auto;\n      max-width: 600px;\n      max-height: 90vh;\n      display: flex;\n      align-items: center;\n      min-height: 0;\n\n      .modal-content {\n        max-width: 100%;\n        max-height: 90vh;\n        display: flex;\n        flex-direction: column;\n        overflow: hidden;\n      }\n\n      .modal-header {\n        flex-shrink: 0;\n      }\n\n      .modal-body {\n        max-height: calc(90vh - 120px);\n        padding: 15px;\n        overflow-y: auto;\n        overflow-x: hidden;\n        flex: 1;\n        min-height: 0;\n      }\n\n      .modal-footer {\n        flex-shrink: 0;\n      }\n    }\n\n    .row {\n      .col-5,\n      .col-6,\n      .col-7 {\n        width: 100% !important;\n        max-width: 100% !important;\n        padding: 0.5rem 0;\n      }\n    }\n\n    @media (max-width: 768px) {\n      .modal-dialog {\n        margin: 10px;\n        max-width: calc(100% - 20px);\n        max-height: 95vh;\n\n        .modal-content {\n          max-height: 95vh;\n        }\n\n        .modal-body {\n          max-height: calc(95vh - 120px);\n        }\n      }\n    }\n  }\n\n  // Mobile responsive disclaimer\n  p.disclaimer {\n    font-size: 0.7rem !important;\n    padding: 5px !important;\n\n    span {\n      font-size: 0.7rem !important;\n\n      ::ng-deep b {\n        font-size: 0.75rem !important;\n      }\n    }\n  }\n\n  // Mobile responsive chat list\n  #chat-list-content {\n    max-height: calc(100vh - 250px) !important;\n    min-height: calc(100vh - 250px) !important;\n    padding: 0 5px;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  // Mobile responsive question/answer\n  .question {\n    margin-left: 5px !important;\n    margin-right: 5px !important;\n    padding: 10px !important;\n    font-size: 0.9rem !important;\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n\n    &::before {\n      left: -15px !important;\n      border-width: 15px !important;\n    }\n  }\n\n  .answer {\n    margin-left: 5px !important;\n    margin-right: 5px !important;\n    padding: 10px !important;\n    font-size: 0.9rem !important;\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n\n    .answer-content::before {\n      left: -25px !important;\n      border-width: 15px !important;\n    }\n  }\n\n  // Better spacing for mobile\n  #botWrapper {\n    padding: 0;\n  }\n\n  // Improve sidebar on mobile\n  .right-sidebar {\n    width: 100% !important;\n    max-width: 100%;\n\n    .tab-content {\n      padding: 10px 5px;\n    }\n\n    .listing-data {\n      padding-left: 0.5rem;\n      padding-right: 0.5rem;\n    }\n  }\n\n  // Improve popup on mobile\n  .ai-assist-popup {\n    .container {\n      padding: 0.5rem;\n    }\n\n    .row {\n      margin: 0;\n    }\n\n    .col-8, .col-4 {\n      padding: 0.5rem;\n    }\n  }\n\n  // Improve modal on mobile\n  .policy-upload {\n    .modal-dialog {\n      margin: 10px;\n      max-width: calc(100% - 20px);\n    }\n\n    .modal-body {\n      padding: 15px 10px;\n      max-height: calc(100vh - 200px);\n      overflow-y: auto;\n    }\n  }\n\n  // Improve chat tools on mobile\n  #chat-tools-wrapper {\n    padding: 8px;\n    flex-wrap: wrap;\n\n    #chat-tools {\n      gap: 12px;\n      flex-wrap: wrap;\n      justify-content: center;\n\n      li {\n        min-width: 44px;\n        min-height: 44px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n    }\n  }\n}\n\n// Very small devices (max-width: 480px)\n@media screen and (max-width: 480px) {\n  app-page-header {\n    .pull-right {\n      .radio-group {\n        flex-direction: column;\n        width: 100%;\n        gap: 8px;\n\n        .radio {\n          width: 100%;\n          min-width: 100%;\n          margin: 0.25rem 0;\n\n          label {\n            font-size: 0.8rem;\n            padding: 8px;\n          }\n        }\n      }\n    }\n\n    .right-menu {\n      .tab-list {\n        width: 100%;\n        justify-content: space-around;\n        gap: 5px;\n\n        li {\n          flex: 1;\n          max-width: 60px;\n          min-width: 44px;\n          min-height: 44px;\n        }\n      }\n    }\n\n    .page-title {\n      font-size: 0.85rem;\n\n      .icon {\n        font-size: 0.8rem;\n      }\n    }\n  }\n\n  #chat-tools-wrapper {\n    padding: 5px;\n\n    #chat-tools {\n      flex-direction: row;\n      align-items: center;\n      gap: 8px;\n      flex-wrap: wrap;\n      justify-content: center;\n\n      .category-dropdown-wrapper {\n        width: 100%;\n        order: -1;\n        margin-bottom: 5px;\n\n        ::ng-deep .p-dropdown {\n          width: 100% !important;\n        }\n      }\n\n      li {\n        min-width: 44px;\n        min-height: 44px;\n        flex: 0 0 auto;\n        justify-content: center;\n        padding: 8px;\n      }\n    }\n  }\n\n  .ai-assist-popup {\n    padding: 0.5rem;\n\n    .pop-content {\n      height: calc(100vh - 280px) !important;\n      max-height: 300px;\n      padding: 10px;\n      font-size: 0.85rem;\n    }\n\n    .list-wrapper.list-overflow {\n      height: calc(100vh - 180px) !important;\n      max-height: 250px;\n    }\n\n    .pop-header {\n      padding: 10px !important;\n      font-size: 0.9rem;\n    }\n\n    .card-content {\n      padding: 10px !important;\n    }\n  }\n\n  .policy-upload {\n    .modal-dialog {\n      margin: 5px;\n      max-width: calc(100% - 10px);\n    }\n\n    .modal-body {\n      padding: 10px 5px;\n      font-size: 0.85rem;\n    }\n\n    .modal-footer {\n      padding: 10px;\n      flex-direction: column;\n      gap: 8px;\n\n      button {\n        width: 100%;\n        margin: 0;\n      }\n    }\n  }\n\n  .question,\n  .answer {\n    margin-left: 5px !important;\n    margin-right: 5px !important;\n    padding: 8px !important;\n    font-size: 0.85rem !important;\n    line-height: 1.4;\n  }\n\n  // Chat list improvements\n  #chat-list-content {\n    max-height: calc(100vh - 280px) !important;\n    min-height: calc(100vh - 280px) !important;\n  }\n\n  // Input box improvements\n  #chat-message-enter-box {\n    border-radius: 1.5rem;\n    padding: 5px;\n\n    #chatForm {\n      padding: 5px;\n    }\n  }\n\n  // Disclaimer text\n  p.disclaimer {\n    font-size: 0.65rem !important;\n    padding: 5px !important;\n    line-height: 1.3;\n  }\n\n  // Sidebar improvements\n  .right-sidebar {\n    .tab-list {\n      padding: 5px;\n\n      li {\n        padding: 8px 5px;\n        font-size: 0.9rem;\n      }\n    }\n  }\n\n  // History/Pin/File items\n  .history-item,\n  .pin-item,\n  .file-item,\n  .audio-item {\n    padding: 10px 5px;\n    font-size: 0.85rem;\n  }\n\n  // Audio player\n  .audio-wrapper {\n    width: 100% !important;\n    max-width: 100%;\n    right: 0;\n    left: 0;\n    padding: 10px;\n\n    audio {\n      width: 100% !important;\n    }\n  }\n}\n\n// Tablet devices (641px - 960px)\n@media screen and (min-width: 641px) and (max-width: 960px) {\n  .bot-middle-content {\n    min-width: 100% !important;\n    max-width: 100%;\n    padding: 0 15px;\n  }\n\n  #chat-list-content {\n    max-width: 100%;\n    padding: 0 10px;\n    max-height: calc(100vh - 200px) !important;\n    min-height: calc(100vh - 200px) !important;\n  }\n\n  app-page-header {\n    .pull-right {\n      width: auto !important;\n      flex-direction: row;\n      align-items: center;\n      flex-wrap: wrap;\n      gap: 10px;\n\n      > span {\n        width: auto !important;\n      }\n\n      .radio-group {\n        width: auto !important;\n        flex-wrap: wrap;\n      }\n    }\n  }\n\n  .ai-assist-popup {\n    .row {\n      flex-direction: row;\n\n      .col-8 {\n        width: 60% !important;\n      }\n\n      .col-4 {\n        width: 40% !important;\n      }\n    }\n  }\n\n  // Chat input\n  #chat-message-enter-box {\n    width: 100%;\n    padding: 10px;\n  }\n\n  // Chat tools\n  #chat-tools-wrapper {\n    padding: 10px;\n\n    #chat-tools {\n      gap: 15px;\n    }\n  }\n\n  // Question/Answer\n  .question,\n  .answer {\n    margin-left: 15px;\n    padding: 12px;\n    font-size: 0.95rem;\n  }\n}\n\n\n\n#botinput-wrapper {\n  width:100%;\n\n  p.disclaimer {\n    color: var(--textsecondarycolor) !important;\n    //font-size:1rem;\n    padding: 0px;\n    //font-family: sans-serif;\n    margin-top:6px;\n     span {\n      display: inline-block;\n      //background: #fff;\n      text-align: center;\n\n     // font-size:1rem;\n      color: var(--textsecondarycolor) !important;\n      // box-shadow:0px 0px 4px rgba(85, 85, 85, 0.4);\n       ::ng-deep b{\n           font-size:.9rem !important;\n       }\n       span{\n        font-size:.75rem;\n       }\n    }\n\n    .expan-down-arrow {\n      display: flex;\n      justify-content: center;\n\n      & a {\n        background-color: #fff;\n        padding: 7px;\n\n        .fa {\n          font-size: 1.5rem !important;\n        }\n      }\n    }\n  }\n}\n\n.bot-middle-content {\n  width: 100%;\n  max-width: 960px;\n  margin: auto;\n  min-width:840px;\n\n  @media screen and (max-width: 840px) {\n    min-width: 100%;\n    padding: 0 10px;\n  }\n}\n\n#template-title {\n  display: inline-flex;\n  width: 100%;\n  font-size: 1rem;\n\n  span:nth-child(1) {\n    width: 80%;\n    text-align: center;\n  }\n\n  span:nth-child(2) {\n    width: 20%;\n  }\n\n  .button {\n    border-color: #fff;\n    border-width: 0px;\n  }\n\n}\n\n#designlist-wrapper {\n  height: 90vh;\n  overflow-y: auto;\n  padding: 0px 20px;\n}\n\n@media screen and (max-width:640px) {\n  .chat-history-list {\n    left: 0px;\n    top: 0px;\n  }\n}\n\n@media screen and (min-width:768px) and (max-width:960px) {\n  #chat-list-content {\n    padding: 1% 3% 0% 1% !important;\n  }\n\n}\n\n\n.checkbox-wrapper .tgl {\n  display: none;\n}\n\n.checkbox-wrapper .tgl,\n.checkbox-wrapper .tgl:after,\n.checkbox-wrapper .tgl:before,\n.checkbox-wrapper .tgl *,\n.checkbox-wrapper .tgl *:after,\n.checkbox-wrapper .tgl *:before,\n.checkbox-wrapper .tgl+.tgl-btn {\n  box-sizing: border-box;\n}\n\n.checkbox-wrapper .tgl::-moz-selection,\n.checkbox-wrapper .tgl:after::-moz-selection,\n.checkbox-wrapper .tgl:before::-moz-selection,\n.checkbox-wrapper .tgl *::-moz-selection,\n.checkbox-wrapper .tgl *:after::-moz-selection,\n.checkbox-wrapper .tgl *:before::-moz-selection,\n.checkbox-wrapper .tgl+.tgl-btn::-moz-selection,\n.checkbox-wrapper .tgl::selection,\n.checkbox-wrapper .tgl:after::selection,\n.checkbox-wrapper .tgl:before::selection,\n.checkbox-wrapper .tgl *::selection,\n.checkbox-wrapper .tgl *:after::selection,\n.checkbox-wrapper .tgl *:before::selection,\n.checkbox-wrapper .tgl+.tgl-btn::selection {\n  background: none;\n}\n\n.checkbox-wrapper .tgl+.tgl-btn {\n  outline: 0;\n  display: block;\n  width: 2.7em;\n  height: 1.4em;\n  position: relative;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.checkbox-wrapper .tgl+.tgl-btn:after,\n.checkbox-wrapper .tgl+.tgl-btn:before {\n  position: relative;\n  display: block;\n  content: \"\";\n  width: 50%;\n  height: 100%;\n}\n\n.checkbox-wrapper .tgl+.tgl-btn:after {\n  left: 0;\n}\n\n.checkbox-wrapper .tgl+.tgl-btn:before {\n  display: none;\n}\n\n.checkbox-wrapper .tgl:checked+.tgl-btn:after {\n  left: 50%;\n}\n\n.checkbox-wrapper .tgl-light+.tgl-btn {\n  background: #b1b1b1;\n  border-radius: 2em;\n  padding: 2px;\n  transition: all 0.4s ease;\n}\n\n.checkbox-wrapper .tgl-light+.tgl-btn:after {\n  border-radius: 50%;\n  background: #fff;\n  transition: all 0.2s ease;\n}\n\n.checkbox-wrapper .tgl-light:checked+.tgl-btn {\n  background: var(--primaryColor) !important;\n}\n\n\n.modal-dialog {\n  .modal-content {\n    max-width: calc(100vw - 50px);\n  }\n\n  .modal-header {\n    justify-content: space-between;\n  }\n\n  .modal-body {\n    max-height: calc(100vh - 150px);\n    overflow-y: auto;\n    scrollbar-width: none;\n  }\n\n  .fa-solid {\n    font-size: 1.5rem !important;\n    color: #fff !important;\n  }\n\n  .btn-primary {\n    background: var(--primaryColor) !important;\n    color: #fff !important;\n  }\n\n  .btn-cancel {\n    background-color: #eee;\n    color: #111;\n  }\n\n  .btn {\n    padding: .3rem .8rem !important;\n  }\n}\n\n.modal.fade {\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.modal.show {\n  display: block;\n}\n\n.modal-header {\n  background: var(--primaryColor);\n  color: #fff;\n}\n\n#scroll-top-button {\n  position: fixed;\n  bottom: 6px;\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  right: 5px;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  background: #fff;\n  box-shadow: 0 0 5px 2px #ddd;\n\n  .fa-arrow-up {\n    font-size: 1.5rem !important;\n  }\n}\n\nul.ai-tools-menu {\n  display: inline;\n  padding: 0px;\n  margin: 0px;\n\n  li {\n    display: inline-flex;\n    align-items: center;\n    margin-right: 15px;\n    cursor: pointer;\n\n    span {\n      padding: 10px 10px 10px 3px;\n      color: #222222;\n      font-size: 0.9rem;\n    }\n\n    .fa {\n      font-size: 0.9rem !important;\n    }\n\n    &.active {\n      color: var(--primaryColor);\n\n      i {\n        color: var(--menuSelectColor) !important;\n      }\n    }\n  }\n}\n\n.custom-radios {\n  form {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: row;\n  }\n\n  label {\n    display: inline-flex;\n    cursor: pointer;\n    font-weight: 500;\n    position: relative;\n    overflow: hidden;\n    margin-bottom: 0.375em;\n\n    /* Accessible outline */\n    /* Remove comment to use */\n    /*\n            &:focus-within {\n                    outline: .125em solid $primary-color;\n            }\n        */\n    input {\n      position: absolute;\n      left: -9999px;\n\n      &:checked+span {\n        background-color: hsla(var(--primaryColor), 84%);\n\n        &:before {\n          box-shadow: inset 0 0 0 0.4375em var(--primaryColor);\n        }\n      }\n    }\n\n    span {\n      display: flex;\n      align-items: center;\n      padding: 0.375em 0.75em 0.375em 0.375em;\n      border-radius: 99em; // or something higher...\n      transition: 0.25s ease;\n      font-size: .9rem;\n      font-weight: bold;\n      color: #666;\n\n      &:before {\n        display: flex;\n        flex-shrink: 0;\n        content: \"\";\n        background-color: #fff;\n        width: 1.5em;\n        height: 1.5em;\n        border-radius: 50%;\n        margin-right: 0.375em;\n        transition: 0.25s ease;\n        box-shadow: inset 0 0 0 0.125em var(--primaryColor);\n      }\n    }\n  }\n}\n\n.radio-wrapper {\n  padding-right: 1.5rem;\n}\n\n.right-sidebar {\n  position: fixed;\n  top: 0;\n  right: -285px;\n  width: 285px;\n  height: 100%;\n  background: #fff;\n  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);\n  transition: right 0.3s ease;\n  z-index: 1000;\n  // padding: 20px;\n\n  @media screen and (max-width: 767px) {\n    width: 100%;\n    max-width: 100%;\n    right: -100%;\n  }\n}\n\n.right-sidebar.open {\n  right: 0;\n\n  @media screen and (max-width: 767px) {\n    right: 0;\n  }\n}\n\n.icon-btn {\n  cursor: pointer;\n  border: none;\n  background: none;\n  font-size: 24px;\n  line-height: 1px;\n  color: #fff;\n\n  &:hover {\n    color: #1571b9;\n  }\n}\n\n.close-btn {\n  position: absolute;\n  top: 0.3rem;\n  right: 0.5rem;\n  font-size: 1.7rem;\n  font-weight: 600;\n  background: transparent;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  min-width: 44px;\n  min-height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1001;\n\n  &:hover {\n    // background-color: #133aa5;\n    // border-radius: 50%;\n    color: #1571b9;\n    // width: 11%;\n  }\n\n  @media screen and (max-width: 767px) {\n    font-size: 20px;\n    top: 0.5rem;\n    right: 0.5rem;\n  }\n}\n\n.tab-list {\n  list-style: none;\n  display: flex;\n  //border-bottom: 1px solid #ccc;\n  padding: 0;\n  // margin: 0 0 20px;\n}\n\n.tab-list li {\n  padding: 13px 10px;\n  cursor: pointer;\n  border: 1px solid transparent;\n  border-bottom: none;\n  width:40px;\n  text-align: center;\n  // margin-right: 5px;\n\n  &:hover {\n    background-color: #86b7fffc;\n    color: #fff !important;\n\n    .fa,.fa-solid {\n      color: var(--icondarkcolor) !important;\n    }\n  }\n}\n\n.tab-list li.active {\n  border: 1px solid #1571b9;\n  border-bottom: 1px solid #1571b9;\n  background-color: #1571b9;\n  color: #fff;\n\n  i.fa {\n    color: #fff !important;\n  }\n}\n\n.tab-content {\n  padding: 10px 0;\n\n  .tab-view {\n    width: 100%;\n\n    ul {\n      li {\n        // padding: 10px;\n\n        &:hover {\n          background-color: #1571b929;\n          color: #1571b9;\n        }\n\n        label {\n          white-space: nowrap;\n          width: 78%;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          cursor: pointer;\n\n          .fa {\n            line-height: 26px;\n            margin-right: 10px;\n          }\n        }\n      }\n    }\n  }\n}\n\n//history tab css\n.history-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px;\n  border-bottom: 1px solid #eee;\n}\n\n.history-item.odd {\n  background-color: #f9f9f9;\n}\n\n.history-label {\n  cursor: pointer;\n  flex: 1;\n}\n\n.history-delete {\n  color: #d9534f;\n  cursor: pointer;\n  margin-left: 10px;\n}\n\n// .history-delete {\n//   right: 11px;\n//   position: absolute;\n//   margin-top: 5px;\n\n//   .fa {\n//     color: #ccc !important;\n\n//     &:hover {\n//       color: #1571b9 !important;\n//     }\n//   }\n// }\n\n// .history-view {\n//   margin-top: 5px;\n\n//   .fa {\n//     color: #ccc !important;\n//     margin-top: 0.5rem;\n\n//     &:hover {\n//       color: #1571b9 !important;\n//     }\n//   }\n// }\n\n//pin tab css\n.pin-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.pin-item.odd {\n  background-color: #f9f9f9;\n}\n\n.pin-label {\n  cursor: pointer;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 500;\n}\n\n.pin-delete,.history-delete {\n  .pi-trash{\n   color: #c10909 !important;\n  }\n\n  cursor: pointer;\n  padding-left: 10px;\n  font-size: 1rem;\n}\n\n//file tab css\n\n.file-item {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 8px;\n  border-bottom: 1px solid #ddd;\n}\n\n.file-item.odd {\n  background-color: #f9f9f9;\n}\n\n.file-label {\n  flex: 1;\n  cursor: pointer;\n  font-weight: 500;\n  color: #333;\n}\n\n.file-date {\n  font-size: 12px;\n  color: #999;\n}\n\n.file-actions {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  margin-left: 10px;\n}\n\n.action-icon {\n  color: #007bff;\n  cursor: pointer;\n  font-size: 1rem;\n}\n\n.action-icon:hover {\n  color: #0056b3;\n}\n\n//audio tab css\n.audio-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 10px;\n  border-bottom: 1px solid #eee;\n  position: relative;\n}\n\n.audio-item.odd {\n  background-color: #f9f9f9;\n}\n\n.audio-info {\n  flex: 1;\n  cursor: pointer;\n}\n\n.audio-label {\n  font-weight: 500;\n  color: #333;\n}\n\n.audio-date {\n  font-size: 12px;\n  color: #999;\n}\n\n.audio-player-wrapper {\n  margin-left: 10px;\n  position: relative;\n}\n\n.audio-play-icon {\n  font-size: 20px;\n  color: #007bff;\n  cursor: pointer;\n}\n\n.audio-wrapper {\n  position: absolute;\n  right: 0;\n  top: 30px;\n  z-index: 10;\n  background: #333;\n  padding: 10px;\n  border-radius: 8px;\n}\n\n.audio-wrapper.hide {\n  display: none;\n}\n\n.close-audio {\n  color: #fff;\n  float: right;\n  cursor: pointer;\n  font-size: 16px;\n  margin-bottom: 5px;\n}\n\n.audio-actions {\n  margin-left: 10px;\n}\n\n.action-icon {\n  font-size: 16px;\n  color: #007bff;\n  cursor: pointer;\n}\n\n.action-icon:hover {\n  color: #0056b3;\n}\n\n.notification-list{\n  margin-left:0px !important;\n  margin-top:0px !important;\n  li{\n    margin-top:0px !important;\n  }\n  .file-item.active{\n      background:#f4f4f4 !important;\n    .file-label{\n    color: var(--textsecondarycolor) !important;\n    }\n  }\n   li{\n    list-style: none !important;\n    &:hover{\n      background:#f0f0f0 !important;\n      .fa,.fa-solid{\n        color: var(--icondarkcolor) !important;\n      }\n    }\n  }\n\n  label.file-label{\n    width:100% !important;\n    max-width:90% !important;\n  }\n}\n.pagination{\n  padding-top:5px !important;\n}\n .fa-microphone-slash.inactive{\n  pointer-events: none !important;\n }\n .ai-assist-popup{\n  .doc-views-tabs{\n    border-bottom-width:0px !important;\n  }\n  .pop-header{\n    background: var(--primaryColor);\n    color:#fff;\n    .fa-solid,.fa{\n      color:#fff !important;\n    }\n  }\n  .card-content{\n    .file-item{\n      border-bottom:0px !important;\n    }\n  }\n  .pop-content{\n    height:calc(100vh - 200px);\n     overflow-y:auto;\n      width:100%;\n      scrollbar-width:3px;\n      color: var(--textsecondarycolor) !important;\n  }\n  .pop-title{\n    text-align: center;\n    margin-left: 50px;\n    width:75%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n  }\n   .content-tab{\n     .level-left{\n      width:100% !important;\n      border: 1px solid #81c2fb;\n     border-radius: 5px;\n     background:#fff !important;\n     border-radius:100px !important;\n      .level-item{\n        width:90%;\n        justify-content: start;\n      }\n      .level-item.input-search-box{\n        .field,.control,.input{\n          width:100%;\n        }\n\n      }\n     }\n   }\n   .list-wrapper.list-overflow{\n    height:calc(100vh - 160px);\n   }\n\n  .card{\n    height:calc(100vh - 70px);\n    overflow-y: auto;\n  }\n\n  .pagination{\n    position: absolute;\n    width: 95%;\n    bottom: 10px;\n  }\n  .menu-options.level{\n    background: #c2eefb !important;\n  }\n\n }\n\n #suggestion-list {\n  width: inherit;\n  font-size: .9rem !important;\n  border-radius: 5px;\n  //margin-top:-3px;\n  box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 2px 2px, rgba(0, 0, 0, 0.09) 0px 2px 4px, rgba(0, 0, 0, 0.09) 0px 2px 8px, rgba(0, 0, 0, 0.09) 0px 2px 5px;\n  max-height: 200px;\n  overflow-y: auto;\n  position: absolute;\n  z-index: 99;\n  top: 43px;\n\n  p {\n    padding: 10px;\n  }\n}\n\n::ng-deep .p-multiselect {\n    min-width: 15rem;\n    width: 90px !important;\n    .p-multiselect-header{\n      display: none;\n    }\n\n}\n\n::ng-deep .p-inputwrapper.p-disabled{\n      background: #eee !important;\n    }\n\n::ng-deep .p-multiselect.p-inputwrapper{\n  border:1px solid #c8c8c8;\n  padding:5px;\n}\n\n::ng-deep .p-multiselect-items-wrapper{\n  background: #fff;\n   border:1px solid #c8c8c8;\n   padding:5px;\n\n   .p-checkbox-box{\n    border:1px solid var(--primaryColor);\n    width:20px;\n    height:20px;\n   }\n}\n\n\n\n::ng-deep .p-inputwrapper.p-disabled{\n      background: #eee !important;\n    }\n\n::ng-deep .p-multiselect.p-inputwrapper{\n  border:1px solid #c8c8c8;\n  padding:5px;\n}\n\n::ng-deep .p-multiselect-items-wrapper{\n  background: #fff;\n   border:1px solid #c8c8c8;\n   padding:5px;\n\n   .p-checkbox-box{\n    border:1px solid var(--primaryColor);\n    width:20px;\n    height:20px;\n   }\n}\n\n\n\n\n\n\n\n span.inactive ::ng-deep .p-dropdown{\n   border: 1px solid red !important;\n  }\n\n::ng-deep .p-dropdown {\n    min-width: 15rem;\n    width: 90px !important;\n    border: 1px solid #dcdcdc;\n    // padding: 5px;\n    border-radius: 8px;\n\n\n    .p-dropdown-items{\n      background: #fff;\n      border:1px solid #dcdcdc;\n\n      border-radius: 5px;\n\n      li{\n        padding:5px;\n        span{\n          text-transform: capitalize;\n        }\n      }\n       li:hover{\n          background: #f4f4f4 !important;\n          color: #171717;\n        }\n\n        li[aria-selected=\"true\"]{\n          background: #eee !important;\n        }\n    }\n\n\n}\n\n.category-dropdown-wrapper {\n  display: flex;\n  align-items: center;\n  padding: 0 5px;\n\n  // ::ng-deep .category-dropdown {\n  //   width: 150px !important;\n  //   min-width: 120px;\n\n  //   .p-dropdown-label {\n  //     font-size: 0.9rem;\n  //     padding: 0.4rem 0.5rem;\n  //   }\n\n  //   .p-dropdown-trigger {\n  //     width: 2rem;\n  //   }\n  // }\n}\n\n.dropdown-trigger{\n  display: none;\n}\n\n.policy-upload{\n  .profile-img {\n    margin:5px;\n    width: auto !important;\n    .img-options{\n    padding-top:0px;\n\n  }\n  }\n  .modal-body{\n    min-height:315px;\n  }\n\n  .file-cta{\n    background: var(--primaryColor);\n    .pi{\n      font-size:1.3rem;\n      color: #fff !important;\n    }\n  }\n}\n\n$color1: #f4f4f4;\n$color2: #3197EE;\n.radio-group{\n  width:250px !important;\n}\n.radio {\n  margin: 0.5rem;\n  input[type=\"radio\"] {\n    position: absolute;\n    opacity: 0;\n    + .radio-label {\n      &:before {\n        content: '';\n        background: $color1;\n        border-radius: 100%;\n        border: 1px solid darken($color1, 25%);\n        display: inline-block;\n        width: 1.4em;\n        height: 1.4em;\n        position: relative;\n        top: -0.1em;\n        margin-right:.5em;\n        vertical-align: top;\n        cursor: pointer;\n        text-align: center;\n        transition: all 250ms ease;\n      }\n    }\n    &:checked {\n      + .radio-label {\n        &:before {\n          background-color: $color2;\n          box-shadow: inset 0 0 0 4px $color1;\n        }\n      }\n    }\n    &:focus {\n      + .radio-label {\n        &:before {\n          outline: none;\n          border-color: $color2;\n        }\n      }\n    }\n    &:disabled {\n      + .radio-label {\n        &:before {\n          box-shadow: inset 0 0 0 4px $color1;\n          border-color: darken($color1, 25%);\n          background: darken($color1, 25%);\n        }\n      }\n    }\n    + .radio-label {\n      &:empty {\n        &:before {\n          margin-right: 0;\n        }\n      }\n    }\n  }\n}\n\n.icon{\n  cursor: pointer;\n}\n.mobileBased-header-section{\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 10px;\n  padding: 10px;\n\n  @media screen and (max-width: 480px) {\n    flex-direction: column;\n    padding: 8px;\n  }\n}\n\n// Modern Dropzone Upload Styles - Within Original Modal Pattern\n.dropzone-upload-wrapper {\n  .dropzone {\n    border: 2px dashed #ccc;\n    border-radius: 0.5rem;\n    text-align: center;\n    padding: 2rem 1.5rem;\n    transition: all 0.3s ease;\n    cursor: pointer;\n    background: #fff;\n    position: relative;\n    margin-bottom: 1rem;\n    min-height: 120px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    &.dragging {\n      background: #f0f8ff;\n      border-color: #1571b9;\n    }\n\n    &.has-file {\n      border-color: #ddd;\n      background: #fafafa;\n    }\n\n    &:hover:not(.has-file) {\n      border-color: #999;\n      background: #f9f9f9;\n    }\n\n    input[type=\"file\"] {\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      top: 0;\n      left: 0;\n      opacity: 0;\n      cursor: pointer;\n    }\n\n    .dropzone-label {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: 0.5rem;\n      color: #444;\n      pointer-events: none;\n\n      .icon {\n        font-size: 2.5rem;\n        color: #1571b9;\n        margin-bottom: 0.25rem;\n      }\n\n      .text {\n        font-size: 0.95rem;\n        color: #333;\n\n        strong {\n          display: block;\n          margin-bottom: 0.25rem;\n        }\n      }\n\n      small {\n        color: #777;\n        font-size: 0.85rem;\n        margin-top: 0.25rem;\n      }\n    }\n  }\n\n  .selected-file-display {\n    margin-top: 1rem;\n\n    .file-item-card {\n      display: flex;\n      align-items: center;\n      gap: 1rem;\n      padding: 1rem 1.25rem;\n      background: #fff;\n      border-radius: 0.5rem;\n      border: 1px solid #e0e0e0;\n      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n      transition: all 0.2s;\n\n      &:hover {\n        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n      }\n\n      .file-icon-wrapper {\n        flex-shrink: 0;\n        width: 48px;\n        height: 48px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background: transparent;\n\n        i {\n          font-size: 2rem;\n          color: #1571b9;\n        }\n      }\n\n      .file-details {\n        flex: 1;\n        min-width: 0;\n        display: flex;\n        flex-direction: column;\n        gap: 0.25rem;\n\n        .selected-file-name {\n          font-weight: 400;\n          color: #333;\n          margin: 0;\n          word-break: break-word;\n          font-size: 0.95rem;\n          line-height: 1.4;\n        }\n\n        .file-size-text {\n          color: #666;\n          font-size: 0.875rem;\n          margin: 0;\n        }\n      }\n\n      .delete-btn {\n        flex-shrink: 0;\n        border: none;\n        background: transparent;\n        color: #999;\n        cursor: pointer;\n        font-size: 1.25rem;\n        padding: 0.5rem;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border-radius: 0.25rem;\n        transition: all 0.2s;\n        width: 32px;\n        height: 32px;\n\n        &:hover {\n          color: #666;\n          background: #f5f5f5;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
